import { Job } from '../../../models/job';
import { JobSalary } from '../../../models/jobSalary';
import { JobMatchQueryFilter } from '../../../models/jobMatchQueryFilter';
import { Requisition } from '../../../models/requisition';
import { SentAssessmentDetail } from '../../../models/sentAssessmentDetail';
import { UiError } from '../../../models/uiError';
import * as UploadReqUpdateLocationModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/uploadreq/upload-req-update-location-modal.html';
import * as UploadReqTransactionsCandidateModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/uploadreq/upload-req-transaction-candidates-modal.html';
import * as UploadReqWorkflowStepWarningModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/uploadreq/upload-req-work-flow-step-warning-modal.html';
import * as UploadReqJobProfileModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/uploadreq/upload-req-job-profile-modal.html';
import * as UploadReqAddEditEndClientTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/uploadreq/upload-req-add-edit-end-client.html';
import { RunCandidateScore } from '../../../models/runCandidateScore';
import { FormalizeCompany, FormalizeRequisition } from '../../../models/formalizePayload';
export class UploadReqPageController {
    /*@ngInject*/
    constructor($rootScope, $scope, $state, $transitions, $uibModal, $sce, $timeout, requisitionService, candidateService, resumeService, jobService, assessmentService, planService, companyService, alertsAndNotificationsService, MESSAGECONSTANTS, uibModalService, utilityService, userService, manageSkillsService, stateManagementStorageService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$transitions = $transitions;
        this.$uibModal = $uibModal;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.requisitionService = requisitionService;
        this.candidateService = candidateService;
        this.resumeService = resumeService;
        this.jobService = jobService;
        this.assessmentService = assessmentService;
        this.planService = planService;
        this.companyService = companyService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.uibModalService = uibModalService;
        this.utilityService = utilityService;
        this.userService = userService;
        this.manageSkillsService = manageSkillsService;
        this.stateManagementStorageService = stateManagementStorageService;
        Dropzone.autoDiscover = false; // disable dropdown instantiation done in the plugin
    }
    _ensureWizardInitialized() {
        const $el = $('#uploadReqWizard');
        this.$timeout(() => {
            if ($el.length && !$el.data('wizard')) {
                $el.wizard();
            }
        }, 300, false);
    }
    $onInit() {
        this.utilityService.showLoadingModal("Loading...");
        this.$stateParams = this.$transition$.params();
        this.isNewReq = (!_.isUndefined(this.$stateParams.isNewReq) && !_.isNull(this.$stateParams.isNewReq)) ? this.$stateParams.isNewReq : null;
        this.asyncActionType = this.$stateParams.asyncActionType ? this.$stateParams.asyncActionType : 'UPLOAD';
        this.isLoading = true;
        this.requisitionSkillsLoading = false;
        this.allExistingSkills = [];
        this.allExistingDegrees = [];
        this.allExistingFieldOfStudy = [];
        this.allExistingRoles = [];
        this.allExistingCertificates = [];
        this.allExistingJDActionWords = [];
        this.allUpdatedJDActionWords = [];
        this.timePeriods = [];
        this.skillsTimePeriods = [];
        this.getAllMasterLists(() => {
            this._initVariables();
            this._initUploadWizard();
            this._handleBrowserEvents();
            this._setContractDurations();
            this.getPlanDetails(() => {
                if (this.isTrialPlanActive) {
                    this.getJobBoardsResumePullLimits();
                }
            });
            this.getSalaryDurationOptions();
            this.getCurrencyCodes();
            this.checkJobBoardsSearchAvailability();
            // if not edit mode
            if (!this.editModeFlag) {
                //initialize the variables
                this.job = new Job();
                this.isJobFetched = true;
                this.showWizardSteps = true;
                this._ensureWizardInitialized();
                this.currentJobStatus = 'DRAFT';
                this.isActivateRequisitionEnabled = false;
                // get all the required values.
                // get clients or bus
                this.getAllClientsOrBu();
                // get recruiters
                // this.getRecruiters();
                // get job types
                this.getAllJobTypes();
                //get work locations
                this.getAllWorkLocations();
                // get sponsorship types
                this.getAllSponsorshipTypes();
                // get tech assessments
                this.getAllTechAssessments();
                // get value assessments
                this.getAllValueAssessments();
                // get job boards
                this.getAllJobBoards();
                this._createStepTempObject(1);
                this.utilityService.hideLoadingModal();
            }
            else {
                // edit mode
                this.getJob(this.$stateParams.jobId, (data) => {
                    this.currentJobStatus = 'OPEN';
                    if (data.jobCurrentState == 'DRAFT') {
                        this.currentJobStatus = 'DRAFT';
                        this.isActivateRequisitionEnabled = false;
                    }
                    else {
                        this._ensureWizardInitialized();
                    }
                    this.showWizardSteps = true;
                    this.req.title = data.title;
                    this.req.isSharedClientRequisition = data.isSharedClientRequisition;
                    this.req.sharedClientBuOrCorpId = data.sharedClientBuOrCorpId;
                    let fileName = this._getFileName(data);
                    let fileSize = data.jobRequisitionList[0].fileSize ? data.jobRequisitionList[0].fileSize : 0;
                    //check if job scoring job in is progress 
                    this.getJobScoringJobStatus();
                    // get clients or bus
                    this.getAllClientsOrBu(() => {
                        this._setClientOrBu(data.clientorbu);
                        this._createStepTempObject(2);
                        if (!this.isCorporate) {
                            this._getSharedClientBus(() => {
                                this.getPointOfContacts(() => {
                                    this._setPocs();
                                });
                            });
                        }
                    });
                    // get recruiters
                    this.getRecruiters(() => {
                        this._setRecruitersAndHiringManagers();
                    });
                    //get bu vendors
                    if (!this.clientOrBUIsRequiredFlag) {
                        this.getBuVendors(() => {
                            this._setBuVendors();
                        });
                    }
                    // get job types
                    this.getAllJobTypes(() => {
                        this._setJobType();
                    });
                    // get job types
                    this.getAllWorkLocations(() => {
                        if (this.job.workLocationIds && this.job.workLocationIds.length > 0) {
                            this._setWorkLocations();
                        }
                    });
                    // get sponsorship types
                    this.getAllSponsorshipTypes(() => {
                        if (this.job.sponsorships) {
                            if (this.job.sponsorships.length > 0) {
                                this._setSponsorshipType();
                            }
                        }
                        else {
                            this._setSponsorshipSelectedDefault(false);
                        }
                    });
                    // get tech assessments
                    this.getAllTechAssessments();
                    // get value assessments
                    this.getAllValueAssessments();
                    // get job boards
                    this.getAllJobBoards(() => {
                        this._setJobBoardDetails();
                    });
                    // get license preferences as job id is available
                    this.getLicensePreferences(() => {
                        this._createWorkflowSliders(() => {
                            this._massageWorkflowStepsOrder();
                        });
                        this.disableNextButtonFlag = false;
                    });
                    if (fileName) {
                        this._setFileInUploadDropZone(fileName, fileSize);
                    }
                    //set the flags for edit mode
                    this.disableUploadButtonFlag = true;
                    this.fileExistsFlag = true;
                    this.step2DetailsSavedFlag = true;
                    this.workflowStepsSavedFlag = true;
                    this.jobBoardsSettingsSavedFlag = true;
                    if (this.isNewReq) {
                        this.utilityService.showLoadingModal("Loading...");
                        this._getCandidateCountBeforeStep5(() => {
                            this._createCountSliders();
                            // find the remove button in the drop zone and delete it.
                            $('.dz-remove').remove();
                            // move to next step as the save is done.
                            $("#uploadReqWizard").wizard('previous');
                            this.utilityService.hideLoadingModal();
                            this.disableSaveButtonFlag = false;
                        }, () => {
                            this.utilityService.hideLoadingModal();
                            this.disableSaveButtonFlag = false;
                            //do nothing. error message will show up. no move to next step.
                        });
                    }
                    if (this.asyncActionType && this.asyncActionType != 'UPLOAD') {
                        this.disableSaveButtonFlag = false;
                    }
                    this._createStepTempObject(1);
                    this.utilityService.hideLoadingModal();
                });
            }
            this._checkIfOutreachEnabled();
        });
        this.setFormalizeActivityPayload();
    }
    _initVariables() {
        this.isJobFetched = false;
        this.isUploadRequisition = true;
        this.isTransitionAbortRequired = true;
        this.userDetails = this.$rootScope.userDetails;
        this.isLocationChange = false;
        this.isLocationChangeInitial = false;
        this.sharedCorporateId = null;
        this.clientorbulist = {};
        this.recruiterList = [];
        this.hiringManagerList = [];
        this.selectedRecruiters = [];
        this.sharedJobPocs = [];
        this.selectedPocs = [];
        this.selectedHiringManagers = [];
        this.selectedPrimaryHiringManager = [];
        this.selectedVendors = [];
        this.salaryDurationOptions = [];
        this.currencyCodes = [];
        this.jobTypeList = [];
        this.selectedJobTypes = [];
        this.workLocationsList = [];
        this.selectedWorkLocationsList = [];
        this.sponsorshipList = [];
        this.selectedSponsorships = [];
        this.techAssessmentList = [];
        this.valueAssessmentList = [];
        this.jobBoardDetails = [];
        this.jobBoardDetailsCopy = [];
        this.resumesToPullPerJobBoardCountCopy = 0;
        this.currentScoreCandidateCounts = {};
        this.adjustedScoreCandidateCounts = {};
        this.candidatesBasedOnRequisitionTransaction = [];
        this.req = {};
        this.job = {};
        this.salaryLabel = "Salary";
        this.reqUploadDropzone = {};
        this.uploadReqWizard = {};
        this.currentJobStatus = null;
        this.matchTypesArray = [];
        this.resumePullCounts = [5, 10, 15, 20, 25];
        this.radiusOptions = [];
        this.recencyOptions = [];
        this.jobBoardParameters = {};
        this.jobBoardParametersMatrix = [];
        this.jobBoardsResumePullLeft = 0;
        this.jobBoardsPullResumePulled = 0;
        this.activeJobBoardsFilterTabNumber = 0;
        this.clientOrBuLabel = 'Client';
        this.primaryHiringManagerId = '';
        this.sharedClientBus = [];
        this.sentTechnicalAssessmentsDetail = new SentAssessmentDetail();
        this.sentValueAssessmentsDetail = new SentAssessmentDetail();
        // Edit requistion details screen
        this.isEditRequisitionDetails = false;
        this.isUploadAndEditRadioBtn = true;
        this.endClient = null;
        this.addEditClientName = "";
        this.endClientSearchText = "";
        this.endClientDeleteMessage = "";
        this.associatedEdClientReqDetails = [];
        //preference objects
        this.intelligencePreferences = {};
        this.techAssessmentPreferences = {};
        this.valueAssessmentPreferences = {};
        this.verificationPreferences = {};
        // flags
        this.isCorporate = false;
        this.editModeFlag = false;
        this.candidatesPresentOnJob = false;
        this.disableWorkflowSettings = false;
        this.isLicensePreferenceSet = false;
        this.isJobBoardDetailsSet = true;
        this.hasClientOrBuChanged = false;
        this.hasJobTypeChanged = false;
        this.isClientOrBuDisabled = false;
        this.isFileUploadEnabled = true;
        this.isInitialStateDraft = false;
        this.clientOrBUIsRequiredFlag = true;
        this.disableUploadButtonFlag = true;
        this.fileExistsFlag = false;
        this.savingFlag = false;
        this.step2DetailsSavedFlag = false;
        this.workflowStepsSavedFlag = false;
        this.jobBoardsSettingsSavedFlag = false;
        this.disablePrevButtonFlag = true;
        this.disableSaveButtonFlag = true;
        this.disableNextButtonFlag = true;
        this.disableCancelButtonFlag = false;
        this.disableAllButtonsFlag = false;
        this.fileUploadInProgressFlag = false;
        this.loadingAdjustedCandidatesCountFlag = false;
        this.step2RequestWasInProgressFlag = false;
        this.step3RequestWasInProgressFlag = false;
        this.step4RequestWasInProgressFlag = false;
        this.step5RequestWasInProgressFlag = false;
        this.step6RequestWasInProgressFlag = false;
        this.editTitleFlag = false;
        this.editJobLocationFlag = false;
        this.editBUFlag = false;
        this.isResumePullEnabled = false;
        this.isJobBoardSelected = false;
        this.isJobIntegrationEnabledByPlan = false;
        this.isTrialPlanActive = false;
        this.isJobBoardServiceUp = true;
        this.isActivateRequisitionEnabled = true;
        this.isAnyWorkflowStepsEnabled = false;
        this.isLoadingSharedClientBus = false;
        this.isClientOrBuRequired = false;
        this.isFutureMatchesOnly = true;
        this.isEndClientNameValid = false;
        this.isManageEndClient = false;
        this.isJobTypeChanged = false;
        this.isAsyncProcess = false;
        this.isJobLocationChanged = false;
        this.isUiCanExit = false;
        this.isOutreachEnabled = false;
        this.isWorkFlowStep4Dot5ScoreChanged = false;
        this.isSkillsChanged = false;
        // temp objects for comparison
        this.step1DetailsTempObject = {};
        this.step2DetailsTempObject = {};
        this.workflowStepsTempObject = {};
        this.jobBoardsSettingsTempObject = {};
        //error objects
        this.step1Error = null;
        this.step2Error = null;
        this.step3Error = null;
        this.step4Error = null;
        this.step5Error = null;
        this.showWizardSteps = false;
        // set add or edit mode
        if (this.$stateParams.jobId != null) {
            this.editModeFlag = true;
            this.isClientOrBuDisabled = true;
            this.isFileUploadEnabled = false;
            this.isUploadRequisition = false;
            this.disableSaveButtonFlag = false;
        }
        if (this.$stateParams.jobState != null && (this.$stateParams.jobState == 'Draft' || this.$stateParams.jobState == 'DRAFT')) {
            this.isInitialStateDraft = true;
        }
        // if corporate, set the BU required flag as false.
        if (this.userDetails.company.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE) {
            this.clientOrBUIsRequiredFlag = false;
            this.clientOrBuLabel = "BU";
        }
        this.isCorporate = this.companyService.isCorporateCompany();
        //initialize the drop zone configuration
        this.reqUploadDropzone = this.createReqUploadDropzone();
        this.req = new Requisition();
        // set the values from session
        this.companyId = this.userDetails.company.companyId;
        this.userId = this.userDetails.id;
        // error objects
        this.step1Error = new UiError();
        this.step2Error = new UiError();
        this.step3Error = new UiError();
        this.step4Error = new UiError();
        this.step5Error = new UiError();
        this.isStepOneActive = true;
        this.isRecalcucateScoreNoClicked = false;
    }
    _setContractDurations() {
        this.contractDurations = ["1", "2", "3", "3+", "4", "5", "6", "6+", "7", "8", "9", "9+", "10", "11", "12", "12+", "15", "18", "21", "24", "Long Term"];
    }
    setDataAfterStep1Saved(data) {
        this._createStepTempObject(data.step + 1);
        if (!this.editModeFlag) {
            this.getRecruiters(() => {
                this._setRecruitersAndHiringManagers();
            });
            if (!this.isCorporate) {
                this.getPointOfContacts(() => {
                    this._setPocs();
                });
            }
            if (!this.clientOrBUIsRequiredFlag) {
                this.getBuVendors(() => {
                    this._setBuVendors();
                });
            }
        }
    }
    _initUploadWizard() {
        // Handle Wizard operations
        $('#uploadReqWizard').on('actionclicked.fu.wizard', (evt, data) => {
            if (data.direction == "next") {
                let currentStep = data.step;
                if (!this.isInitialStateDraft) {
                    //last step will be handled by finished.fu.wizard
                    if (currentStep == 5) {
                        currentStep = 1000;
                    }
                }
                //last step will be handled by finished.fu.wizard
                if (currentStep == 6) {
                    currentStep = 1000;
                }
                switch (currentStep) {
                    case 1:
                        this.isStepOneActive = true;
                        //set the temp object for the next step
                        if (this._isStepDataValid(data.step)) {
                            if (this._hasStepDataChanged(data.step)) {
                                if (this.currentJobStatus == 'DRAFT' && !this.job.id) {
                                    this.createRequisitionWithouFile(() => {
                                        this.setDataAfterStep1Saved(data);
                                    }, (error) => {
                                        evt.preventDefault();
                                    });
                                }
                                else {
                                    if (this.currentJobStatus == 'DRAFT') {
                                        this._saveStep1(false, () => {
                                            this.setDataAfterStep1Saved(data);
                                        }, (error) => {
                                            evt.preventDefault();
                                        });
                                    }
                                    else {
                                        evt.preventDefault();
                                        this.alertsAndNotificationsService.showConfirm("Recalculate Score", "Re-calculate the scores now?", "warning", true, () => {
                                            this._saveStep1(true, () => {
                                                this.setDataAfterStep1Saved(data);
                                                // this.reRunResumeScore(null, () => {});
                                                $("#uploadReqWizard").wizard('next');
                                                this.isRecalcucateScoreNoClicked = false;
                                            }, (error) => {
                                                evt.preventDefault();
                                            });
                                        }, () => {
                                            this._saveStep1(false, () => {
                                                this.setDataAfterStep1Saved(data);
                                                $("#uploadReqWizard").wizard('next');
                                                this.isRecalcucateScoreNoClicked = true;
                                            }, () => {
                                                evt.preventDefault();
                                            });
                                        });
                                    }
                                }
                            }
                            else {
                                if (this.isRecalcucateScoreNoClicked) {
                                    this.alertsAndNotificationsService.showConfirm("Recalculate Score", "Re-calculate the scores now?", "warning", true, () => {
                                        this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => { });
                                    }, () => {
                                        this.isRecalcucateScoreNoClicked = true;
                                    });
                                }
                            }
                        }
                        else {
                            this.$timeout(() => {
                                this.forms.step1Form.$submitted = true;
                                this.step1Error.hasErrorFlag = true;
                                this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                            }, 100);
                            // prevent the move. Validation errors will show up.
                            evt.preventDefault();
                        }
                        break;
                    case 2:
                        this.isStepOneActive = false;
                        if (this.step2RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            this._enableStepActionsOnWizard(data.step);
                        }
                        else {
                            // there was no step2 request or save in progress. the event was triggered by user click of next button
                            if (this._isStepDataValid(data.step)) {
                                if (this._hasStepDataChanged(data.step)) {
                                    if (this._hasRecruitersBeingUnAssigned() || this._hasVendorsBeingUnAssigned()) {
                                        evt.preventDefault();
                                        if (this._hasRecruitersBeingUnAssigned() && this._hasVendorsBeingUnAssigned()) {
                                            // show both warnings
                                            let warningMessage = this._getAssignedRecruitersWarningMessage();
                                            warningMessage = warningMessage + "<br><br>" + this._getVendorsRemovedWarningMessage();
                                            this._showWarningMessage(warningMessage, () => {
                                                this._saveStep2AndMoveToNextStep('NEXT');
                                            }, () => {
                                                this.job.vendorIds = angular.copy(this.step2DetailsTempObject.vendorIds);
                                                this._setBuVendors();
                                                this.job.recruiters = angular.copy(this.step2DetailsTempObject.recruiters);
                                                this._setRecruitersAndHiringManagers();
                                            });
                                        }
                                        else if (this._hasVendorsBeingUnAssigned()) {
                                            this._showVendorsRemovedWarning(() => {
                                                this._saveStep2AndMoveToNextStep('NEXT');
                                            }, () => {
                                                this.job.vendorIds = angular.copy(this.step2DetailsTempObject.vendorIds);
                                                this._setBuVendors();
                                            });
                                        }
                                        else {
                                            this._showRecruitersUnAssignedWarning(() => {
                                                this._saveStep2AndMoveToNextStep('NEXT');
                                            }, () => {
                                                this.job.recruiters = angular.copy(this.step2DetailsTempObject.recruiters);
                                                this._setRecruitersAndHiringManagers();
                                            });
                                        }
                                    }
                                    else {
                                        this.step2RequestWasInProgressFlag = true;
                                        this.utilityService.showLoadingModal("Saving...");
                                        this.saveStep2Details('NEXT', () => {
                                            // if this is not edit mode and if workflow steps were not already saved, get license preferences
                                            if (!(this.editModeFlag && this.workflowStepsSavedFlag) || (this.hasClientOrBuChanged || this.hasJobTypeChanged)) {
                                                this.getAllTechAssessments(() => {
                                                    this.getAllValueAssessments(() => {
                                                        this.getLicensePreferences(() => {
                                                            this._createStepTempObject(data.step + 1);
                                                            this._createStepTempObject(data.step + 2);
                                                            this._createWorkflowSliders(() => {
                                                                this._massageWorkflowStepsOrder();
                                                                this.hasClientOrBuChanged = false;
                                                                this.hasJobTypeChanged = false;
                                                            });
                                                            // move to next step as the saves and gets are done.
                                                            this.utilityService.hideLoadingModal();
                                                            $("#uploadReqWizard").wizard('next');
                                                        }, () => {
                                                            this.utilityService.hideLoadingModal();
                                                            this._enableStepActionsOnWizard(data.step);
                                                            //do nothing. error message will show up. no move to next step.
                                                        });
                                                    });
                                                });
                                            }
                                            else {
                                                // move to next step as the save is done.
                                                this.utilityService.hideLoadingModal();
                                                $("#uploadReqWizard").wizard('next');
                                            }
                                        }, (error) => {
                                            this.utilityService.hideLoadingModal();
                                            this._enableStepActionsOnWizard(data.step);
                                            // show error messages
                                            if (this.$rootScope.isOnline) {
                                                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                            }
                                            // no move to next step.
                                        });
                                    }
                                }
                                else {
                                    // if this is not edit mode and if workflow steps were not already saved, get license preferences
                                    if (!(this.editModeFlag && this.workflowStepsSavedFlag) || (this.hasClientOrBuChanged || this.hasJobTypeChanged)) {
                                        this.step2RequestWasInProgressFlag = true;
                                        this.getAllTechAssessments(() => {
                                            this.getAllValueAssessments(() => {
                                                this.getLicensePreferences(() => {
                                                    this._createStepTempObject(data.step + 1);
                                                    this._createStepTempObject(data.step + 2);
                                                    this._createWorkflowSliders(() => {
                                                        this._massageWorkflowStepsOrder();
                                                        this.hasClientOrBuChanged = false;
                                                        this.hasJobTypeChanged = false;
                                                    });
                                                    // move to next step as the gets are done.
                                                    $("#uploadReqWizard").wizard('next');
                                                }, () => {
                                                    this._enableStepActionsOnWizard(data.step);
                                                    //do nothing. error message will show up. no move to next step.
                                                });
                                            });
                                        });
                                    }
                                    else {
                                        // step data valid and not add mode
                                        this._createStepTempObject(data.step + 1);
                                        this._createStepTempObject(data.step + 2);
                                    }
                                }
                            }
                            else {
                                this.$timeout(() => {
                                    this.forms.step2Form.$submitted = true;
                                    this.step2Error.hasErrorFlag = true;
                                    this.step2Error.errorMessage = 'Please enter all mandatory fields.';
                                }, 100);
                                // prevent the move. Validation errors will show up.
                                evt.preventDefault();
                            }
                            // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                            if (this.step2RequestWasInProgressFlag) {
                                // prevent default move.
                                evt.preventDefault();
                                this.disableAllButtonsFlag = true;
                            }
                        }
                        break;
                    case 3:
                        if (this.step3RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            // this.step3RequestWasInProgressFlag = false;
                            // this.disableAllButtonsFlag = false;
                            this._enableStepActionsOnWizard(data.step);
                        }
                        else {
                            this._parseWorkflowStepsOrderBeforeSave();
                            if (this._isStepDataValid(data.step)) {
                                if (this._hasStepDataChanged(data.step)) {
                                    if (this.currentJobStatus == 'DRAFT') {
                                        this._updateDataAfterWorkflowStepsSavedNextClicked(false, data, () => {
                                            $("#uploadReqWizard").wizard('next');
                                        }, () => { });
                                    }
                                    else {
                                        if (this.hasMatchingMandatoryCriteriaChanged() || this.hasMissingPreferenceDetailsChanged()) {
                                            this.alertsAndNotificationsService.showConfirm("Recalculate Score", "Re-calculate the scores now?", "warning", true, () => {
                                                this._updateDataAfterWorkflowStepsSavedNextClicked(true, data, () => {
                                                    // this.reRunResumeScore(null, () => { });
                                                    // $("#uploadReqWizard").wizard('next');
                                                }, () => { });
                                            }, () => {
                                                this._updateDataAfterWorkflowStepsSavedNextClicked(false, data, () => {
                                                    // $("#uploadReqWizard").wizard('next');
                                                    this.isRecalcucateScoreNoClicked = true;
                                                }, () => { });
                                            });
                                        }
                                        else {
                                            this._updateDataAfterWorkflowStepsSavedNextClicked(false, data, () => {
                                                $("#uploadReqWizard").wizard('next');
                                            }, () => { });
                                        }
                                    }
                                }
                                else {
                                    this.step3RequestWasInProgressFlag = true;
                                    this.utilityService.showLoadingModal("Loading...");
                                    this.getJobBoardParameters(() => {
                                        this.getRadiusAndRecencyOptions(() => {
                                            this._createStepTempObject(data.step + 1);
                                            $("#uploadReqWizard").wizard('next');
                                            this.utilityService.hideLoadingModal();
                                        }, (error) => {
                                            this._enableStepActionsOnWizard(data.step);
                                            this.utilityService.hideLoadingModal();
                                            //do nothing. error message will show up. no move to next step.
                                        });
                                    }, () => {
                                        this._enableStepActionsOnWizard(data.step);
                                        this.utilityService.hideLoadingModal();
                                        //do nothing. error message will show up. no move to next step.
                                    });
                                }
                            }
                            else {
                                this.$timeout(() => {
                                    this.forms.step3Form.$submitted = true;
                                    //check all the values one by one.
                                    this.step3Error.hasErrorFlag = true;
                                    this.step3Error.errorMessage = 'Please enter all mandatory fields.';
                                }, 100);
                                // prevent the move. Validation errors will show up.
                                evt.preventDefault();
                            }
                            // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                            if (this.step3RequestWasInProgressFlag) {
                                // prevent default move.
                                evt.preventDefault();
                                this.disableAllButtonsFlag = true;
                            }
                        }
                        break;
                    case 4:
                        if (this.step4RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            this._enableStepActionsOnWizard(data.step);
                        }
                        else {
                            if (this._isStepDataValid(data.step)) {
                                if (this._hasStepDataChanged(data.step)) {
                                    this.step4RequestWasInProgressFlag = true;
                                    this.saveJobBoardsSettings('NEXT', () => {
                                        if (this.isInitialStateDraft) {
                                            this.disableNextButtonFlag = this.isActivateRequisitionEnabled ? false : true;
                                            $("#uploadReqWizard").wizard('next');
                                        }
                                        else {
                                            let successMessage = "";
                                            if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                                                successMessage = successMessage + "Pulling and matching candidates from job boards";
                                                this.alertsAndNotificationsService.showBannerMessage(successMessage, 'info');
                                            }
                                            // }
                                            this._pullResumesAndGetCandidateCountInOpen();
                                        }
                                    }, (error) => {
                                        this._enableStepActionsOnWizard(data.step);
                                        // show error messages
                                        if (this.$rootScope.isOnline) {
                                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                        }
                                        // no move to next step
                                    });
                                }
                                else {
                                    this.step4RequestWasInProgressFlag = true;
                                    // the current job might not have been saved in Open state yet (if it is an edit of a draft job).
                                    if (this.isInitialStateDraft) {
                                        //will be enabled when activate requisition chosen
                                        this.$timeout(() => {
                                            $("#uploadReqWizard").wizard('next');
                                        }, 100);
                                        this.disableNextButtonFlag = this.isActivateRequisitionEnabled ? false : true;
                                    }
                                    else {
                                        let successMessage = "";
                                        if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                                            successMessage = successMessage + "Pulling and matching candidates from job boards";
                                            this.alertsAndNotificationsService.showBannerMessage(successMessage, 'info');
                                        }
                                        this._pullResumesAndGetCandidateCountInOpen();
                                    }
                                }
                            }
                            else {
                                // prevent the move. Validation errors will show up.
                                evt.preventDefault();
                            }
                            // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                            if (this.step4RequestWasInProgressFlag) {
                                // prevent default move.
                                evt.preventDefault();
                                this.disableAllButtonsFlag = true;
                            }
                        }
                        break;
                    case 5:
                        if (this.step5RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            // this.step5RequestWasInProgressFlag = false;
                            // this.disableAllButtonsFlag = false;
                            this._enableStepActionsOnWizard(data.step);
                        }
                        else {
                            if (this.currentJobStatus == 'DRAFT') {
                                this.step5RequestWasInProgressFlag = true;
                                this._setJobStateToOpenAndRunForScoring(() => {
                                    let message = "Requisition activation process has started in the background and will inform all users on the Requisition when its completed.";
                                    this.alertsAndNotificationsService.showAlertWithCallBack("Requisition Activation", message, "success", () => {
                                        this.$state.go('missioncontrol.requisitions');
                                    });
                                }, () => { });
                                if (this.step5RequestWasInProgressFlag) {
                                    // prevent default move.
                                    evt.preventDefault();
                                    this.disableAllButtonsFlag = true;
                                }
                            }
                        }
                        break;
                    case 6:
                        if (this.step6RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            this._enableStepActionsOnWizard(currentStep);
                        }
                        else {
                            if (this._hasStepDataChanged(currentStep) || this.isWorkFlowStep4Dot5ScoreChanged) {
                                this.step6RequestWasInProgressFlag = true;
                                let adjustedScore = $('.slider-adjust-4dot5-score').val();
                                // need to save adjusted score as the current 4dot5 intelligence score
                                this.saveAdjusted4dot5Score(adjustedScore, (data) => {
                                    this.sendOutreachEmailToCandidates(data.candidatesToMatch);
                                    this.isWorkFlowStep4Dot5ScoreChanged = false;
                                    // move to next step as the save is done.
                                    $("#uploadReqWizard").wizard('next');
                                }, (error) => {
                                });
                            }
                            else {
                                this.sendOutreachEmailToCandidates(this.currentScoreCandidateCounts.candidatesToMatch);
                            }
                            // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                            if (this.step6RequestWasInProgressFlag) {
                                // prevent default move.
                                evt.preventDefault();
                                this.disableAllButtonsFlag = true;
                            }
                        }
                        if (this.isRecalcucateScoreNoClicked) {
                            this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => { });
                        }
                        break;
                    default:
                        break;
                }
            }
            else if (data.direction == "previous") {
                if (data.step == 6)
                    data.step = 5;
                switch (data.step) {
                    case 1:
                        this.isStepOneActive = true;
                        // not possible
                        break;
                    case 2:
                        this.isStepOneActive = false;
                        break;
                    case 3:
                        this._createStepTempObject(data.step - 1);
                        break;
                    case 4:
                        this._createStepTempObject(data.step - 1);
                        break;
                    case 5:
                        this.disableNextButtonFlag = false;
                        break;
                    case 6:
                        this._createStepTempObject(data.step - 1);
                        break;
                    default:
                        break;
                }
            }
        });
        $('#uploadReqWizard').on('finished.fu.wizard', (evt) => {
            let currentStep = 6;
            if (this.step6RequestWasInProgressFlag) {
                // save or request was in progress and it is now completed. The success has has triggered a next event.
                // set the flag, do nothing and move to next step.
                this._enableStepActionsOnWizard(currentStep);
            }
            else {
                if (this._hasStepDataChanged(currentStep) || this.isWorkFlowStep4Dot5ScoreChanged) {
                    this.step6RequestWasInProgressFlag = true;
                    let adjustedScore = $('.slider-adjust-4dot5-score').val();
                    //setting to avoid Unsaved data pop up when navigating to requisitions screen
                    this.isInitialStateDraft = false;
                    // need to save adjusted score as the current 4dot5 intelligence score
                    this.saveAdjusted4dot5Score(adjustedScore, (data) => {
                        this.sendOutreachEmailToCandidates(data.candidatesToMatch);
                        this.isWorkFlowStep4Dot5ScoreChanged = false;
                        //go to requisitions screen
                        this.$state.go('missioncontrol.requisitions');
                    }, (error) => {
                    });
                }
                else {
                    //setting to avoid Unsaved data pop up when navigating to requisitions screen
                    this.isInitialStateDraft = false;
                    this.sendOutreachEmailToCandidates(this.currentScoreCandidateCounts.candidatesToMatch);
                    this.$state.go('missioncontrol.requisitions');
                }
                // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                if (this.step6RequestWasInProgressFlag) {
                    // prevent default move.
                    evt.preventDefault();
                    this.disableAllButtonsFlag = true;
                }
            }
            if (this.isRecalcucateScoreNoClicked) {
                this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => { });
            }
        });
        $('#uploadReqWizard').on('changed.fu.wizard', (evt, data) => {
            switch (data.step) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    this.updateActionButtons();
                    break;
            }
        });
    }
    setJDActionsValues(actionWord, key, fallbackKey = "value") {
        return actionWord[key] ? actionWord[key][fallbackKey] : "";
    }
    setJDActionWords() {
        this.allExistingJDActionWords.forEach(jdAction => {
            if (jdAction.jobDescriptionLanguageDropdown && jdAction.jobDescriptionLanguageDropdown.length > 0) {
                jdAction.jobDescriptionLanguageDropdown.forEach(actionWord => {
                    let actionWordTemp = { name: actionWord, jdAction: jdAction };
                    this.allUpdatedJDActionWords.push(actionWordTemp);
                });
            }
        });
        const prepositions = [" in ", " with ", " of ", " at "];
        this.allUpdatedJDActionWords.forEach(actionWord => {
            prepositions.forEach(preposition => {
                this.skillsTimePeriods.push({
                    name: `${actionWord.name}${preposition}`,
                    value: {
                        minExperienceInMonths: this.setJDActionsValues(actionWord.jdAction, 'minExperienceInMonths'),
                        maxExperienceInMonths: this.setJDActionsValues(actionWord.jdAction, 'maxExperienceInMonths'),
                        plusTo: this.setJDActionsValues(actionWord.jdAction, "minExperienceInMonths", "sign"),
                        months: 0,
                        range: "",
                        isJDActionWord: true,
                        jdAction: actionWord
                    }
                });
            });
        });
    }
    setTimePeriodsForTypeAhead() {
        this.timePeriods = this.manageSkillsService.setTimePeriodsInRequisitionSkillsTypeAhead();
        this.skillsTimePeriods = [];
        let timePeriodsWithExperience = [];
        this.timePeriods.forEach(skill => {
            let tempSkill = Object.assign({}, skill);
            this.skillsTimePeriods.push(tempSkill);
            let experienceInSkill = Object.assign({}, skill, { name: skill.name + 'experience in ' });
            this.skillsTimePeriods.push(experienceInSkill);
            let experienceWithSkill = Object.assign({}, skill, { name: skill.name + 'experience with ' });
            this.skillsTimePeriods.push(experienceWithSkill);
            let experienceOfSkill = Object.assign({}, skill, { name: skill.name + 'experience of ' });
            this.skillsTimePeriods.push(experienceOfSkill);
            let experienceSkill = Object.assign({}, skill, { name: skill.name + 'experience ' });
            timePeriodsWithExperience.push(experienceSkill);
        });
        this.setJDActionWords();
        this.timePeriods = [...this.timePeriods, ...timePeriodsWithExperience];
    }
    getAllMasterLists(successCallback) {
        this.isLoading = true;
        let completedRequests = 0;
        let totalRequests = 6;
        const checkCompletion = () => {
            completedRequests++;
            if (completedRequests === totalRequests) {
                setTimeout(() => {
                    this.setTimePeriodsForTypeAhead();
                }, 50);
                setTimeout(() => {
                    this.isLoading = false;
                    if (successCallback) {
                        successCallback();
                    }
                }, 100);
            }
        };
        this.getAllSkills(() => checkCompletion());
        this.getDegreesEntities(() => checkCompletion());
        this.getFieldOfStudyEntities(() => checkCompletion());
        this.getRoles(() => checkCompletion());
        this.getCertificates(() => checkCompletion());
        this.getJdActions(() => checkCompletion());
    }
    getAllSkills(successCallback) {
        let filterObject = {
            searchSkill: '',
            searchByParentSkill: '',
            searchCategory: '',
            sortColumn: 'skill',
            sortDir: 'ASC',
            includeAlternateSkills: false
        };
        this.allExistingSkills = [];
        this.jobService.getAllSkills(filterObject, (data) => {
            this.allExistingSkills = data ? data.allSkills.filter(skill => skill) : [];
            if (successCallback) {
                successCallback();
            }
        }, error => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getDegreesEntities(successCallback) {
        let degreeFilerObj = {
            searchDegree: '',
            sortColumn: '',
            sortDir: ''
        };
        this.allExistingDegrees = [];
        this.manageSkillsService.getAllDegreesEntityLists(degreeFilerObj, (data) => {
            this.allExistingDegrees = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getFieldOfStudyEntities(successCallback) {
        let fieldOfStudyObj = {
            searchFieldOfStudy: '',
            sortColumn: '',
            sortDir: ''
        };
        this.manageSkillsService.getAllFieldOfStudyLists(fieldOfStudyObj, (data) => {
            this.allExistingFieldOfStudy = [];
            this.allExistingFieldOfStudy = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getRoles(successCallback) {
        let roleObj = {
            searchRole: '',
            sortColumn: '',
            sortDir: ''
        };
        this.manageSkillsService.getAllCandidateRolesLists(roleObj, (data) => {
            this.allExistingRoles = [];
            this.allExistingRoles = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getCertificates(successCallback) {
        let certificatesObj = {
            searchName: '',
            sortColumn: '',
            sortDir: ''
        };
        this.manageSkillsService.getAllCertificationsLists(certificatesObj, (data) => {
            this.allExistingCertificates = [];
            this.allExistingCertificates = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getJdActions(successCallback) {
        let jdActionsObj = {
            searchName: '',
            sortColumn: '',
            sortDir: ''
        };
        this.manageSkillsService.getAllJdActionsLists(jdActionsObj, (data) => {
            this.allExistingJDActionWords = [];
            this.allExistingJDActionWords = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    updateRequisitionDetails() {
        if (!this.isUploadRequisition) {
            this.disableSaveButtonFlag = false;
            if (this.isCorporate || (this.req.clientOrBU && this.req.clientOrBU.id)) {
                this.disableNextButtonFlag = false;
            }
            else {
                this.disableNextButtonFlag = true;
            }
            if (this.step1Error.hasErrorFlag) {
                this.step1Error.errorMessage = 'Please enter all mandatory fields.';
            }
        }
        else {
            this.disableSaveButtonFlag = true;
            this.disableNextButtonFlag = true;
            if (this.step1Error.hasErrorFlag) {
                this.step1Error.errorMessage = '';
            }
        }
    }
    _getFileName(requisition) {
        if (requisition.jobRequisitionList[0].originalRequisitionName != null) {
            return requisition.jobRequisitionList[0].originalRequisitionName;
        }
        else {
            if (requisition.jobRequisitionList[0].fileName) {
                let fileName = requisition.jobRequisitionList[0].fileName;
                for (let i = 0; i < 2; i++) {
                    let index = fileName.indexOf('-');
                    fileName = fileName.substring(index + 1);
                }
                return fileName;
            }
            else {
                return null;
            }
        }
    }
    _hasRecruitersBeingUnAssigned() {
        return this.step2DetailsTempObject.recruiters.length > this.job.recruiters.length;
    }
    _hasVendorsBeingUnAssigned() {
        return this.step2DetailsTempObject.vendorIds.length > this.job.vendorIds.length;
    }
    _saveStep1(isRerun, successCallback, errorCallback) {
        this.disableAllButtonsFlag = true;
        this.savingFlag = true;
        this.requisitionSkillsLoading = true;
        this.saveStep1Details(isRerun, () => {
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            this.requisitionSkillsLoading = false;
            this._createStepTempObject(1);
            this.isSkillsChanged = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            this.requisitionSkillsLoading = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    _saveStep2(buttonType) {
        this.disableAllButtonsFlag = true;
        this.savingFlag = true;
        this.utilityService.showLoadingModal("Saving...");
        this.saveStep2Details(buttonType, () => {
            this.utilityService.hideLoadingModal();
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            if (this.$rootScope.isOnline) {
                let successMessage = 'The Requisition details have been saved in Draft Status.';
                if (this.currentJobStatus == 'OPEN') {
                    successMessage = 'The Requisition details have been saved.';
                }
                this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
            }
            this._createStepTempObject(2);
        }, (error) => {
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _saveStep2AndMoveToNextStep(buttonType) {
        this.step2RequestWasInProgressFlag = true;
        this.utilityService.showLoadingModal("Saving...");
        this.saveStep2Details(buttonType, () => {
            // if this is not edit mode and if workflow steps were not already saved, get license preferences
            if ((!(this.editModeFlag) && !(this.workflowStepsSavedFlag)) || (this.hasClientOrBuChanged)) {
                this.getAllTechAssessments(() => {
                    this.getAllValueAssessments(() => {
                        this.getLicensePreferences(() => {
                            this._createStepTempObject(data.step + 1);
                            this._createStepTempObject(data.step + 2);
                            this._createWorkflowSliders(() => {
                                this._massageWorkflowStepsOrder();
                                this.hasClientOrBuChanged = false;
                            });
                            // move to next step as the saves and gets are done.
                            this.utilityService.hideLoadingModal();
                            $("#uploadReqWizard").wizard('next');
                        }, () => {
                            this.utilityService.hideLoadingModal();
                            this._enableStepActionsOnWizard(data.step);
                            //do nothing. error message will show up. no move to next step.
                        });
                    });
                });
            }
            else {
                this.utilityService.hideLoadingModal();
                // move to next step as the save is done.
                $("#uploadReqWizard").wizard('next');
            }
        }, (error) => {
            this.utilityService.hideLoadingModal();
            this._enableStepActionsOnWizard(data.step);
            // show error messages
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            // no move to next step.
        });
    }
    _showRecruitersUnAssignedWarning(saveCallback, cancelCallback) {
        let warningMessage = this._getAssignedRecruitersWarningMessage();
        this._showWarningMessage(warningMessage, () => {
            saveCallback();
        }, () => {
            cancelCallback();
        });
    }
    _getAssignedRecruitersWarningMessage() {
        let removedRecruiterIds = _.difference(this.step2DetailsTempObject.recruiters, this.job.recruiters);
        console.log(removedRecruiterIds);
        let recruiterNames = [];
        angular.forEach(removedRecruiterIds, (recruiterId, recruiterIdIndex) => {
            angular.forEach(this.recruiterList, (recruiter, recruiterIndex) => {
                if (recruiterId == recruiter.userId) {
                    recruiterNames.push(recruiter.firstName + recruiter.lastName);
                }
            });
        });
        let message = "<b>";
        let totalCount = recruiterNames.length;
        angular.forEach(recruiterNames, (name, index) => {
            if (index == totalCount - 1) {
                message = message + name;
            }
            else if (index == totalCount - 2) {
                message = message + name + " & ";
            }
            else {
                message = message + name + ", ";
            }
        });
        let messageEnd = totalCount > 1 ? "</b> shall be removed as assigned recruiters from all the candidates in the requisition. " : "</b> shall be removed as assigned recruiter from all the candidates in the requisition. ";
        return message + messageEnd;
    }
    _showVendorsRemovedWarning(saveCallback, cancelCallback) {
        let warningMessage = this._getVendorsRemovedWarningMessage();
        this._showWarningMessage(warningMessage, () => {
            saveCallback();
        }, () => {
            cancelCallback();
        });
    }
    _getVendorsRemovedWarningMessage() {
        let removedVendorIds = _.difference(this.step2DetailsTempObject.vendorIds, this.job.vendorIds);
        console.log(removedVendorIds);
        let vendorNames = [];
        angular.forEach(removedVendorIds, (vendorId, vendorIdIndex) => {
            angular.forEach(this.vendorsList, (vendor, vendorIndex) => {
                if (vendorId == vendor.vendorId) {
                    vendorNames.push(vendor.vendorName);
                }
            });
        });
        let message = "All the candidates, if any, related to <b>";
        let totalCount = vendorNames.length;
        angular.forEach(vendorNames, (name, index) => {
            if (index == totalCount - 1) {
                message = message + name;
            }
            else if (index == totalCount - 2) {
                message = message + name + " & ";
            }
            else {
                message = message + name + ", ";
            }
        });
        let messageEnd = totalCount > 1 ? "</b> vendors will be released. " : "</b> vendor will be released. ";
        return message + messageEnd;
    }
    _showWarningMessage(warningMessage, saveCallback, cancelCallback) {
        warningMessage = warningMessage + '<br>Do you still want to continue?';
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: warningMessage,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    saveCallback();
                }
                else {
                    cancelCallback();
                }
            }
        });
    }
    getPlanDetails(successCallback) {
        this.planService.getCompanyPlanDetails(this.companyId, (data) => {
            if (!_.isNull(data)) {
                if (data !== "" && !_.isNull(data.features) && data.features.length) {
                    let jobIntegrationDetails = _.find(data.features, { 'name': "Job Board Integration", 'available': true });
                    this.isJobIntegrationEnabledByPlan = _.isUndefined(jobIntegrationDetails) ? false : true;
                    if (!this.isJobIntegrationEnabledByPlan) {
                        this.isResumePullEnabled = false;
                    }
                    this.isTrialPlanActive = data.plan == "Trial" ? true : false;
                    successCallback();
                }
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _massageWorkflowStepsOrder() {
        let jobType = _.filter(this.jobTypeList, (jobType) => {
            return jobType.value == this.job.jobType;
        });
        if (jobType.length > 0) {
            this.selectedJobType = jobType[0].name;
            this._setJobType();
        }
        this.workflowStepsOrder = angular.copy(this.job.workflowStepsOrder);
        this.isAnyWorkflowStepsEnabled = false;
        //setting id for dnd list to work
        angular.forEach(this.workflowStepsOrder, (steps, jobType) => {
            let stepsDetails = [];
            angular.forEach(steps, (step, index) => {
                let isStepEnabled = true;
                if (step == "Recruiter Screening") {
                    isStepEnabled = this.job.recruiterScreening && this.recruiterScreeningPreferences.enabled;
                }
                else if (step == "Tech Assessment") {
                    isStepEnabled = this.job.techAssessment && this.techAssessmentPreferences.enabled;
                }
                else if (step == "Value Assessment") {
                    isStepEnabled = this.job.valueAssessment && this.valueAssessmentPreferences.enabled;
                }
                else if (step == "Phone Screen") {
                    isStepEnabled = this.job.phoneScreen && this.phoneScreenPreferences.enabled;
                }
                else if (step == "Interview") {
                    isStepEnabled = this.job.interview && this.interviewPreferences.enabled;
                }
                if (isStepEnabled) {
                    this.isAnyWorkflowStepsEnabled = true;
                }
                stepsDetails.push({ id: index, stepName: step, enabled: isStepEnabled, jobType: jobType });
            });
            this.workflowStepsOrder[jobType] = angular.copy(stepsDetails);
        });
        this.workflowStepsOrderToRender = angular.copy(this.workflowStepsOrder);
        angular.forEach(this.workflowStepsOrderToRender, (steps, jobType) => {
            steps.splice(0, 1);
            steps.splice(steps.length - 1, 1);
        });
    }
    _parseWorkflowStepsOrderBeforeSave() {
        angular.forEach(this.workflowStepsOrder, (steps, jobType) => {
            let stepDetails = [];
            angular.forEach(steps, (step, index) => {
                if (index !== 0 && index !== steps.length - 1) {
                    stepDetails.push(this.workflowStepsOrderToRender[jobType][index - 1]);
                }
                else {
                    stepDetails.push(step);
                }
            });
            this.workflowStepsOrder[jobType] = angular.copy(stepDetails);
        });
        let workflowStepsOrderCopy = angular.copy(this.workflowStepsOrder);
        angular.forEach(this.workflowStepsOrder, (steps, jobType) => {
            let stepsDetails = [];
            angular.forEach(steps, (step, index) => {
                stepsDetails.push(step.stepName);
            });
            workflowStepsOrderCopy[jobType] = angular.copy(stepsDetails);
        });
        this.job.workflowStepsOrder = angular.copy(workflowStepsOrderCopy);
    }
    stepMoved($index, jobType) {
        this.workflowStepsOrderToRender[jobType].splice($index, 1);
    }
    getSalaryDurationOptions() {
        this.jobService.getSalaryDurationOptions((data) => {
            this.allSalaryDurationOptions = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getCurrencyCodes() {
        this.jobService.getCurrencyCodes((data) => {
            this.currencyCodes = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    checkJobBoardsSearchAvailability() {
        this.jobService.checkJobBoardsSearchAvailability((data) => {
            this.isJobBoardServiceUp = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _checkIfOutreachEnabled() {
        // this.candidateService.getOutreachEmailEnabledStatus((data) => {
        //     this.isOutreachEnabled = data;
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        this.isOutreachEnabled = true;
    }
    getJobBoardsResumePullLimits() {
        this.planService.getAvailableJobBoardsPullCount(this.companyId, (data) => {
            this.jobBoardsResumePullLeft = data["jobBoardResumesLeftCount"];
            this.jobBoardsPullResumePulled = data["jobBoardResumesPulledCount"];
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getJobBoardParameters(successCallback, errorCallback) {
        this.jobService.getJobBoardParameters((data) => {
            this.jobBoardParameters = data;
            this.parseJobBoardParameters();
            successCallback(data);
        }, (error) => {
            errorCallback();
        });
    }
    getJobBoardsSearchJobStatus(successCallback, errorCallback) {
        this.jobService.getGetMoreResumesJobStatus(this.job.id, (jobInProgress) => {
            successCallback(jobInProgress);
        }, (error) => {
            errorCallback(error);
        });
    }
    parseJobBoardParameters() {
        angular.forEach(this.job.jobBoardDetails, (val, key) => {
            if (!_.isNull(val.daxtraCode)) {
                let flags = [];
                let jobBoardsParams = this.jobBoardParameters.jobBoardParameterMap[val.daxtraCode];
                flags.push(true); // location supported by all job boards
                flags.push(this._isParameterSupported(jobBoardsParams, "postcode"));
                flags.push(this._isParameterSupported(jobBoardsParams, "radius"));
                flags.push(this._isParameterSupported(jobBoardsParams, "jobType"));
                flags.push(this._isParameterSupported(jobBoardsParams, "recency"));
                flags.push(this._isParameterSupported(jobBoardsParams, "education"));
                flags.push(this._isParameterSupported(jobBoardsParams, "industry"));
                flags.push(this._isParameterSupported(jobBoardsParams, "salary"));
                val.flags = flags;
            }
        });
        this.jobBoardDetailsCopy = angular.copy(this.job.jobBoardDetails);
        this.jobBoardsSettingsTempObject.jobBoardDetails = angular.copy(this.job.jobBoardDetails);
    }
    _isParameterSupported(jobBoardParameters, parameter) {
        return (jobBoardParameters.indexOf(parameter) == -1) ? false : true;
    }
    getRadiusAndRecencyOptions(successCallback, errorCallback) {
        this.jobService.getRadiusAndRecencyOptions((data) => {
            // console.log('options');
            // console.log(data);
            this.radiusOptions = data.radius;
            this.recencyOptions = data.recency;
            if (_.isNull(this.job.radius)) {
                this.job.radius = data.defaultRadius[0];
                this.isJobBoardDetailsSet = false;
            }
            if (_.isNull(this.job.recency)) {
                this.job.recency = data.defaultRecency[0];
            }
            successCallback(data);
        }, (error) => {
            errorCallback();
        });
    }
    /**
     * creates the requisition upload drop zone.
     */
    createReqUploadDropzone() {
        let reqUploadDropzone = new Dropzone("form#reqUploadDropzone", {
            url: this.requisitionService.getUploadUrl(),
            paramName: "file",
            acceptedFiles: ".pdf,.xlsx,.docx,.doc",
            maxFiles: 1,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            addRemoveLinks: true,
            autoProcessQueue: false,
            clickable: this.isFileUploadEnabled,
            timeout: 300000,
        });
        // add event handlers for the drop zone
        reqUploadDropzone.on('addedfile', (file, response) => {
            this.fileExistsFlag = true;
            this.updateActionButtons();
            // set the progress bar so that it is properly visible
            $('.dz-progress').css({ top: '70%' });
        });
        reqUploadDropzone.on('removedfile', (file, response) => {
            this.fileExistsFlag = false;
            this.isClientOrBuDisabled = false;
            //reset the job object
            this.job = new Job();
            this.updateActionButtons();
            // Edit requisition Details
            this.isEditRequisitionDetails = false;
        });
        reqUploadDropzone.on('sending', (file, xhr, formData) => {
            // disable the upload button to avoid multiple clicks
            this.disableUploadButtonFlag = true;
            this.isClientOrBuDisabled = true;
            // indicate that file upload is in progress
            this.fileUploadInProgressFlag = true;
            formData.append('companyId', this.userDetails.company.companyId);
            formData.append('isSharedClientRequisition', this.req.isSharedClientRequisition);
            if (this.req.clientOrBU) {
                formData.append('buId', this.req.clientOrBU.id);
            }
            if (this.req.sharedClientBuOrCorpId !== null) {
                formData.append('sharedClientBuOrCorpId', this.req.sharedClientBuOrCorpId);
            }
            formData.append('userId', this.userDetails.id);
        });
        reqUploadDropzone.on('success', (file, response) => {
            // remove file upload in progress flag
            this.fileUploadInProgressFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.UPLOAD.UPLOAD_SUCCESS, 'success');
            // merge the response into the job object
            this.job = this._parseJobResponse(response);
            this._setSponsorshipSelectedDefault(false);
            this._createStepTempObject(1);
            this._createStepTempObject(2);
            this.getAllJobBoards(() => {
                this._setJobBoardDetails();
            });
            if (!this.editModeFlag) {
                this.getRecruiters(() => {
                    this._setRecruitersAndHiringManagers();
                });
                if (!this.isCorporate) {
                    this.getPointOfContacts(() => {
                        this._setPocs();
                    });
                }
                if (!this.clientOrBUIsRequiredFlag) {
                    this.getBuVendors(() => {
                        this._setBuVendors();
                    });
                }
            }
            // this._massageWorkflowStepsOrder();
            this.updateActionButtons();
            // Edit requisition Details
            this.isEditRequisitionDetails = true;
            this.isUploadRequisition = false;
            this.isUploadAndEditRadioBtn = false;
        });
        reqUploadDropzone.on("error", (file, error) => {
            let elements = document.querySelectorAll(".dz-file-preview");
            angular.forEach(elements, (element, index) => {
                let filename = element.querySelectorAll(".dz-filename span")[0].textContent;
                let errorMessage = element.querySelectorAll(".dz-error-message span")[0];
                if (filename === file.name) {
                    errorMessage.textContent = error.message == undefined ? error : error.message;
                }
            });
        });
        return reqUploadDropzone;
    }
    getJob(jobId, successCallback) {
        this.jobService.getJob(jobId, (data) => {
            if (this.editMcurrentJobStatus != 'DRAFT') {
                // Set requisition icons
                this.requisitionInfo = _.cloneDeep(data);
                this.requisitionInfo.workflowSteps = this.$stateParams.workflowSteps;
                this.requisitionInfo.fourDotFiveIntelligentThresholdScore = this.$stateParams.fourDotFiveIntelligentThresholdScore;
                this.requisitionInfo.vendorsDetails = this.$stateParams.vendorsDetails;
                this.requisitionInfo.autoMatedMatchEnabled = true;
                this.requisitionInfo.autoMatedMatchSelected = false;
            }
            this.job = this._parseJobResponse(data);
            if (data.jobCurrentState == 'COMPLETED' || data.jobCurrentState == 'CANCELED') {
                this.disableWorkflowSettings = true;
            }
            // this._massageWorkflowStepsOrder();
            successCallback(data);
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _parseJobResponse(data) {
        this.isJobFetched = true;
        let tempJob = new Job();
        tempJob.id = data.id;
        tempJob.title = data.title;
        tempJob.sharedClientBuOrCorpId = data.sharedClientBuOrCorpId;
        tempJob.isSharedClientRequisition = data.isSharedClientRequisition;
        tempJob.company = {
            name: data.company.name,
            id: data.company.id,
            shortName: data.company.shortName
        };
        if (_.isNull(data.clientorbu)) {
            tempJob.clientorbu = null;
        }
        else {
            tempJob.clientorbu = {
                name: data.clientorbu.name,
                id: data.clientorbu.id,
                shortName: data.clientorbu.shortName
            };
        }
        tempJob.requisitionNumber = data.requisitionNumber;
        tempJob.jobType = data.jobType;
        tempJob.contractDuration = data.contractDuration;
        tempJob.requisitionNote = data.requisitionNote;
        tempJob.jobSalary = angular.copy(data.jobSalary);
        tempJob.location = data.location;
        tempJob.locationLabel = '-';
        if (!_.isNull(tempJob.location)) {
            if (!_.isNull(data.location.city)) {
                tempJob.locationLabel = data.location.city;
            }
            if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel == '-') {
                tempJob.locationLabel = data.location.state;
                if (_.isNull(tempJob.locationLabel)) {
                    tempJob.locationLabel = '-';
                }
            }
            else {
                if (!_.isNull(data.location.state)) {
                    tempJob.locationLabel += ', ' + data.location.state;
                }
            }
            if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel == '-') {
                tempJob.locationLabel = data.location.zipcode ? data.location.zipcode : data.location.zipCode;
                if (_.isNull(tempJob.locationLabel)) {
                    tempJob.zipCode = '-';
                }
            }
            else {
                if (data.location.zipcode || data.location.zipCode) {
                    tempJob.locationLabel += ', ' + (data.location.zipcode ? data.location.zipcode : data.location.zipCode);
                }
            }
        }
        // set the transaction id of the last requisition in the requisition list as job's transaction id
        tempJob.transactionId = data.jobRequisitionList[(data.jobRequisitionList.length - 1)].transactionId;
        tempJob.openings = data.numberOfOpenings;
        tempJob.sponsorships = data.sponsorships;
        tempJob.workLocationIds = data.workLocations ? data.workLocations.map(workLocation => workLocation.id) : [];
        tempJob.workLocations = data.workLocations;
        tempJob.sponsorshipProvided = data.sponsorshipProvided;
        tempJob.recruiters = data.recruiters.map((recruiter) => {
            return recruiter.id;
        });
        tempJob.hiringManagers = data.hiringManagers.map((manager) => {
            return { id: manager.user.id, isPrimary: manager.isPrimary };
        });
        if (!_.isNull(data.pointOfContact)) {
            tempJob.pointOfContactUserId = data.pointOfContact.id;
        }
        else {
            tempJob.pointOfContactUserId = null;
        }
        // Set End Client
        tempJob.endClient = data.endClient;
        this._setEndClient(tempJob);
        tempJob.vendorIds = data.vendorIds;
        tempJob.educationList = data.educationList;
        tempJob.score = data.fourDotFiveIntelligenceScore;
        tempJob.licensePreferences = data.licensePreferences;
        this.isLicensePreferenceSet = data.licensePreferences !== null;
        tempJob.radius = data.radius;
        tempJob.recency = data.recency;
        tempJob.salary = data.salary;
        data.location.zipcode = null;
        tempJob.industry = data.industry;
        tempJob.workflowStepsOrder = data.workflowStepsOrder;
        if (!_.isNull(data.techAssessmentId) && this.$stateParams.jobState != 'Completed' && this.$stateParams.jobState != 'Canceled') {
            tempJob.techAssessmentId = data.techAssessmentId;
            tempJob.techAssessmentScore = data.techAssessmentScore;
            this._getSentAssessmentsCount(tempJob.techAssessmentId, 'Technical', tempJob.id);
        }
        if (!_.isNull(data.valueAssessmentId) && this.$stateParams.jobState != 'Completed' && this.$stateParams.jobState != 'Canceled') {
            tempJob.valueAssessmentId = data.valueAssessmentId;
            this._getSentAssessmentsCount(tempJob.valueAssessmentId, 'Value', tempJob.id);
        }
        tempJob.jobBoardDetails = angular.copy(this.jobBoardDetails);
        if (!_.isNull(tempJob.licensePreferences) && !_.isNull(tempJob.licensePreferences.jobBoardDetails)) {
            angular.forEach(tempJob.jobBoardDetails, (val, key) => {
                if (_.findIndex(tempJob.licensePreferences.jobBoardDetails, { 'boardId': val.boardId, 'enabled': true }) == -1) {
                    val.enabled = false;
                }
            });
        }
        this.jobBoardDetailsCopy = angular.copy(tempJob.jobBoardDetails);
        if (!_.isNull(tempJob.licensePreferences) && !_.isNull(tempJob.licensePreferences.resumesToPullPerJobBoardCount)) {
            tempJob.resumesToPullPerJobBoardCount = data.licensePreferences.resumesToPullPerJobBoardCount;
            this.resumesToPullPerJobBoardCountCopy = tempJob.resumesToPullPerJobBoardCount;
            tempJob.isResumePullEnabled = false;
        }
        tempJob.daxtraParameters = data.daxtraParameters;
        if (!(_.isNull(data.daxtraParameters) || _.isUndefined(data.daxtraParameters)) && !(_.isNull(data.advancedParametersImage) || _.isUndefined(data.advancedParametersImage))) {
            this.activeJobBoardsFilterTabNumber = 1;
        }
        tempJob.advancedParametersImage = this.$sce.trustAsResourceUrl(data.advancedParametersImage);
        tempJob.salaryLabel = "Salary Details";
        if (data.jobType && (data.jobType == 'CONTRACTOR' || data.jobType == 'CONTRACTTOHIRE')) {
            tempJob.salaryLabel = this.isCorporate || tempJob.isSharedClientRequisition ? "Bill Rate" : "Client/Bill Rate";
        }
        tempJob.jobTypeLabel = (data.jobType && this.jobTypeList.length > 0) ? this.jobTypeList.filter(jobType => jobType.value == data.jobType)[0].name : null;
        tempJob.requisitionSalaryDisplayMessage = this.requisitionService._getSalaryDetailsDisplayMessage(tempJob.jobSalary ? tempJob.jobSalary : new JobSalary(), this.allSalaryDurationOptions);
        if (_.isNull(tempJob.sponsorshipProvided) || _.isUndefined(tempJob.sponsorshipProvided)) {
            tempJob.sponsorshipsDisplayMessage = "Sponsorship information not specified";
        }
        else if (_.isNull(tempJob.sponsorships) || tempJob.sponsorships.length == 0) {
            tempJob.sponsorshipsDisplayMessage = "Not Available";
        }
        else if (tempJob.sponsorships.length > 0) {
            tempJob.sponsorshipsDisplayMessage = "";
            let message = "";
            angular.forEach(tempJob.sponsorships, (sponsor, key) => {
                if (key == tempJob.sponsorships.length - 1) {
                    message = message + sponsor;
                }
                else if (key == tempJob.sponsorships.length - 2) {
                    message = message + sponsor + " and ";
                }
                else {
                    message = message + sponsor + ", ";
                }
            });
            tempJob.sponsorshipsDisplayMessage = message;
        }
        tempJob.profileCriteriaInfo = data.profileCriteriaInfo;
        tempJob.includeCandidatesWithNoAdditionalDetails = data.licensePreferences ? data.licensePreferences.includeCandidatesWithNoAdditionalDetails : false;
        tempJob.includeCandidatesMatchingMandatoryCriteria = data.licensePreferences ? data.licensePreferences.includeCandidatesMatchingMandatoryCriteria : false;
        return tempJob;
    }
    _getSentAssessmentsCount(assessmentId, assessmentType, jobId) {
        this.jobService.getAssessmentDetails(assessmentId, jobId, (data) => {
            if (assessmentType == 'Technical') {
                this.sentTechnicalAssessmentsDetail = data;
            }
            else {
                this.sentValueAssessmentsDetail = data;
            }
        }, (error) => {
        });
    }
    _setJobStateToOpenAndRunForScoring(successCallback, errorCallback) {
        this.utilityService.showLoadingModal("Saving...");
        this.setJobStatusToOpen(() => {
            this.currentJobStatus = "OPEN";
            $('.dz-remove').remove();
            this._pullResumesAndGetCandidateCountInDraft(() => {
                this.utilityService.hideLoadingModal();
                this.runJobForScoring(() => { });
                this._getCandidateCountBeforeStep5(() => {
                    this._createCountSliders();
                    $('.dz-remove').remove();
                }, () => { });
                if (successCallback) {
                    successCallback();
                }
            }, () => {
                if (errorCallback) {
                    errorCallback();
                }
            });
        }, () => {
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    _pullResumesAndGetCandidateCountInDraft(successCallback, errorCallback) {
        if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
            this.getJobBoardsSearchJobStatus((jobStatus) => {
                if (jobStatus == true) {
                    this.alertsAndNotificationsService.showBannerMessage("Candidates Fetch from Job Boards already <b>'INPROGRESS'</b>. Please try after sometime.", 'info');
                    if (successCallback) {
                        successCallback();
                    }
                }
                else {
                    this.getResumesFromJobBoards(() => {
                        let successMessage = "";
                        if (this.job.autoMatch) {
                            successMessage = successMessage + "Matched candidates from system ";
                            if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                                successMessage = successMessage + "and pulled and matched candidates from job boards";
                            }
                        }
                        else {
                            if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                                successMessage = successMessage + "Pulled candidates from job board";
                            }
                        }
                        this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                        if (successCallback) {
                            successCallback();
                        }
                    }, (error) => {
                        this.utilityService.hideLoadingModal();
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        if (errorCallback) {
                            errorCallback();
                        }
                        ;
                    });
                }
            }, (error) => {
                this.utilityService.hideLoadingModal();
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                if (errorCallback) {
                    errorCallback();
                }
                ;
            });
        }
        else {
            if (successCallback) {
                successCallback();
            }
        }
    }
    _pullResumesAndGetCandidateCountInOpen() {
        if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
            this.getJobBoardsSearchJobStatus((jobStatus) => {
                if (jobStatus == true) { //job in progress
                    this.alertsAndNotificationsService.showBannerMessage("Candidates Fetch from Job Boards already <b>'INPROGRESS'</b>. Please try after sometime.", 'info');
                    this._enableStepActionsOnWizard(data.step);
                }
                else {
                    this.getResumesFromJobBoards(() => {
                        this._getCandidateCountBeforeStep5(() => {
                            this._createCountSliders();
                            let successMessage = "";
                            if (this.job.autoMatch) {
                                successMessage = successMessage + "Matched candidates from system ";
                                if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                                    successMessage = successMessage + "and pulled and matched candidates from job boards";
                                }
                                this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                            }
                            else {
                                if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
                                    successMessage = successMessage + "Pulled and matched candidates from job boards";
                                    this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                                }
                            }
                            // move to next step as the save is done.
                            $("#uploadReqWizard").wizard('next');
                        }, () => {
                            this._enableStepActionsOnWizard(data.step);
                            //do nothing. error message will show up. no move to next step.
                        });
                    }, (error) => {
                        //end of resume pull
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        this._enableStepActionsOnWizard(data.step);
                    });
                }
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                this._enableStepActionsOnWizard(data.step);
            });
        }
        else {
            this.utilityService.showLoadingModal("Loading...");
            this._getCandidateCountBeforeStep5(() => {
                this._createCountSliders();
                $("#uploadReqWizard").wizard('next');
                this.utilityService.hideLoadingModal();
            }, () => {
                this._enableStepActionsOnWizard(data.step);
                this.utilityService.hideLoadingModal();
                //do nothing. error message will show up. no move to next step.
            });
        }
    }
    _getCandidateCountBeforeStep5(successCallback, errorCallback) {
        this.getCandidateCount(this.job.score, 'currentScore', () => {
            if (successCallback) {
                successCallback();
            }
        }, () => {
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    _createStepTempObject(currentStep) {
        switch (currentStep) {
            case 1:
                let clientOrBUIdStepOne = !this.job.clientorbu ? null : this.job.clientorbu.id;
                this.step1DetailsTempObject = {
                    jobId: this.job.id,
                    title: this.job.title,
                    isSharedClientRequisition: this.currentJobStatus !== 'DRAFT' ? this.job.isSharedClientRequisition : this.req.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.currentJobStatus !== 'DRAFT' ? this.job.sharedClientBuOrCorpId : this.req.sharedClientBuOrCorpId,
                    clientOrBUId: clientOrBUIdStepOne,
                    requistionNumber: this.job.requisitionNumber,
                    isFutureMatchesOnly: this.isFutureMatchesOnly,
                    profileCriteriaInfo: _.cloneDeep(this.job.profileCriteriaInfo),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    tab: this.currentJobStatus !== 'DRAFT' ? 'EDIT_REQUISITION' : 'ADD_REQUISITION'
                };
                break;
            case 2:
                let clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
                this.step2DetailsTempObject = {
                    jobId: this.job.id,
                    title: this.job.title,
                    isSharedClientRequisition: this.job.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.job.sharedClientBuOrCorpId,
                    clientOrBUId: clientOrBUId,
                    requistionNumber: this.job.requisitionNumber,
                    openings: this.job.openings,
                    jobType: this.job.jobType,
                    contractDuration: this.job.contractDuration,
                    requisitionNote: this.job.requisitionNote,
                    jobSalary: angular.copy(this.job.jobSalary),
                    sponsorships: this.job.sponsorships,
                    sponsorshipProvided: this.job.sponsorshipProvided,
                    workLocationIds: this.job.workLocationIds,
                    recruiters: this.job.recruiters,
                    hiringManagers: angular.copy(this.job.hiringManagers),
                    pointOfContactUserId: angular.copy(this.job.pointOfContactUserId),
                    vendorIds: this.job.vendorIds,
                    salary: this.job.salary,
                    tab: "ASSIGN_RECRUITERS",
                    endClientId: this.job.endClientId
                };
                break;
            case 3:
                this.workflowStepsTempObject = {
                    jobId: this.job.id,
                    score: this.job.score,
                    autoMatch: this.job.autoMatch,
                    recruiterScreening: this.job.recruiterScreening,
                    techAssessmentId: this.job.techAssessmentId,
                    techAssessmentScore: this.job.techAssessmentScore,
                    techAssessment: this.job.techAssessment,
                    valueAssessmentId: this.job.valueAssessmentId,
                    valueAssessment: this.job.valueAssessment,
                    eduVerification: this.job.eduVerification,
                    expVeification: this.job.expVeification,
                    phoneScreen: this.job.phoneScreen,
                    interview: this.job.interview,
                    imageProctoring: this.job.imageProctoring,
                    addProctoringImagesToReport: this.job.addProctoringImagesToReport,
                    workflowStepsOrder: angular.copy(this.job.workflowStepsOrder),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    // jobBoardDetails: angular.copy(this.job.jobBoardDetails),
                    // resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
                    tab: "WORKFLOW_STEPS"
                };
                break;
            case 4:
                this.jobBoardsSettingsTempObject = {
                    // jobId: this.job.id,
                    // autoMatch: this.job.autoMatch,
                    jobBoardDetails: angular.copy(this.job.jobBoardDetails),
                    resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
                    isResumePullEnabled: this.job.isResumePullEnabled,
                    radius: this.job.radius,
                    recency: this.job.recency,
                    tab: "JOB_BOARDS"
                };
                break;
            case 5:
                break;
            case 6:
                break;
            default:
                break;
        }
    }
    _isStepDataValid(currentStep) {
        let stepDataValidityFlag = true;
        switch (currentStep) {
            case 1:
                this.forms.step1Form.$submitted = true;
                if (this.req.clientOrBU && this.req.clientOrBU.id && ((this.currentJobStatus == 'DRAFT' && (this.job.title && this.job.title != '')) || this.currentJobStatus != 'DRAFT')) {
                    if (this.req.clientOrBU.companyType === 'Corporation') {
                        if (this.sharedClientBuOrCorp && this.sharedClientBuOrCorp.id) {
                            stepDataValidityFlag = true;
                            this.step1Error.hasErrorFlag = false;
                            this.step1Error.errorMessage = '';
                        }
                        else {
                            stepDataValidityFlag = false;
                            this.step1Error.hasErrorFlag = true;
                            this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                        }
                    }
                    else {
                        stepDataValidityFlag = true;
                        this.step1Error.hasErrorFlag = false;
                        this.step1Error.errorMessage = '';
                    }
                }
                else {
                    if (this.isCorporate && (this.currentJobStatus != 'DRAFT' || (this.currentJobStatus === 'DRAFT' && (this.job.title && this.job.title != '')))) {
                        stepDataValidityFlag = true;
                        this.step1Error.hasErrorFlag = false;
                        this.step1Error.errorMessage = '';
                    }
                    else {
                        stepDataValidityFlag = false;
                        this.step1Error.hasErrorFlag = true;
                        this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                    }
                }
                break;
            case 2:
                // set the form to submitted
                this.forms.step2Form.$submitted = true;
                //check all the values one by one.
                if (this.forms.step2Form.$invalid || (this.job.jobType == null) || (this.job.recruiters.length == 0) || (this.job.sponsorshipProvided && this.job.sponsorships.length == 0) || (this.job.workLocationIds.length == 0) || (this.job.hiringManagers.length > 0 && !this.isPrimaryHiringManagerSelected()) || (this.job.vendorIds.length > 0 && _.isNull(this.job.pointOfContactUserId))) {
                    this.step2Error.hasErrorFlag = true;
                    this.step2Error.errorMessage = 'Please enter all mandatory fields.';
                    stepDataValidityFlag = false;
                }
                else {
                    this.step2Error.hasErrorFlag = false;
                    this.step2Error.errorMessage = '';
                }
                break;
            case 3:
                // set the form to submitted
                this.forms.step3Form.$submitted = true;
                //check all the values one by one.
                if (this.forms.step3Form.$invalid) {
                    this.step3Error.hasErrorFlag = true;
                    this.step3Error.errorMessage = 'Please enter all mandatory fields.';
                    stepDataValidityFlag = false;
                }
                else {
                    this.step3Error.hasErrorFlag = false;
                    this.step3Error.errorMessage = '';
                }
                break;
            case 4:
                break;
            default:
                break;
        }
        return stepDataValidityFlag;
    }
    removeUnusedSkills(skills) {
        const skillsArray = [
            'educations',
            'experiences',
            'technicalSkills',
            'operationalSkills',
            'softSkills',
            'otherSkills',
            'certifications'
        ];
        skillsArray.forEach((skill) => {
            if (skills[skill]) {
                skills[skill] = skills[skill]
                    .filter(item => item.displayName && item.displayName.trim() !== '')
                    .map(item => (Object.assign({}, item, { range: !item.range ? "" : (item.displayName && item.displayName.includes(item.range)) ? item.range : "", plusTo: !item.plusTo ? "" : item.plusTo })));
            }
            else {
                skills[skill] = [];
            }
        });
    }
    setProfileCriteria(obj1, obj2) {
        const newObj = {};
        const keys = Object.keys(obj1);
        keys.forEach(key => {
            const val1 = obj1[key];
            const val2 = obj2[key];
            if (Array.isArray(val1) && Array.isArray(val2)) {
                if (val1.length !== val2.length) {
                    newObj[key] = val2;
                }
                else {
                    newObj[key] = val1.map((item, index) => {
                        const newItem = {};
                        const item2 = val2[index] || {};
                        Object.keys(item).forEach(subKey => {
                            newItem[subKey] = item2[subKey];
                        });
                        return newItem;
                    });
                }
            }
            else {
                if (!val1) {
                    newObj[key] = val2;
                }
                else if (!val2) {
                    newObj[key] = [];
                }
                else {
                    newObj[key] = val2;
                }
            }
        });
        return newObj;
    }
    _hasStepDataChanged(currentStep) {
        let stepDataHasChangedFlag = false;
        switch (currentStep) {
            case 1:
                let clientOrBUIdStepOne = !this.job.clientorbu ? null : this.job.clientorbu.id;
                let currentStep1DataObject = {
                    jobId: this.job.id,
                    title: this.job.title,
                    isSharedClientRequisition: this.currentJobStatus !== 'DRAFT' ? this.job.isSharedClientRequisition : this.req.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.currentJobStatus !== 'DRAFT' ? this.job.sharedClientBuOrCorpId : this.req.sharedClientBuOrCorpId,
                    clientOrBUId: clientOrBUIdStepOne,
                    requistionNumber: this.job.requisitionNumber,
                    isFutureMatchesOnly: this.isFutureMatchesOnly,
                    profileCriteriaInfo: _.cloneDeep(this.job.profileCriteriaInfo),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    tab: this.currentJobStatus !== 'DRAFT' ? 'EDIT_REQUISITION' : 'ADD_REQUISITION'
                };
                let step1DetailsTempObject = _.cloneDeep(this.step1DetailsTempObject);
                this.removeUnusedSkills(step1DetailsTempObject.profileCriteriaInfo);
                this.removeUnusedSkills(currentStep1DataObject.profileCriteriaInfo);
                currentStep1DataObject.profileCriteriaInfo = this.setProfileCriteria(step1DetailsTempObject.profileCriteriaInfo, currentStep1DataObject.profileCriteriaInfo);
                this.isSkillsChanged = !_.isEqual(step1DetailsTempObject.profileCriteriaInfo, currentStep1DataObject.profileCriteriaInfo);
                stepDataHasChangedFlag = !_.isEqual(step1DetailsTempObject, currentStep1DataObject);
                break;
            case 2:
                let clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
                let currentStep2DataObject = {
                    jobId: this.job.id,
                    isSharedClientRequisition: this.job.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.job.sharedClientBuOrCorpId,
                    clientOrBUId: clientOrBUId,
                    requistionNumber: this.job.requisitionNumber,
                    openings: this.job.openings,
                    title: this.job.title,
                    jobType: this.job.jobType,
                    contractDuration: this.job.contractDuration,
                    requisitionNote: this.job.requisitionNote,
                    jobSalary: angular.copy(this.job.jobSalary),
                    sponsorships: this.job.sponsorships,
                    sponsorshipProvided: this.job.sponsorshipProvided,
                    workLocationIds: this.job.workLocationIds,
                    recruiters: this.job.recruiters,
                    hiringManagers: angular.copy(this.job.hiringManagers),
                    vendorIds: this.job.vendorIds,
                    pointOfContactUserId: this.job.pointOfContactUserId,
                    salary: this.job.salary,
                    tab: "ASSIGN_RECRUITERS",
                    endClientId: this.job.endClientId
                };
                stepDataHasChangedFlag = !(_.isEqual(this.step2DetailsTempObject, currentStep2DataObject));
                // set hasClientOrBuChanged to true if client or bu changed and save/next clicked
                if (!this.hasClientOrBuChanged) {
                    this.hasClientOrBuChanged = !(_.isEqual(this.step2DetailsTempObject.clientOrBUId, currentStep2DataObject.clientOrBUId));
                }
                if (this.hasClientOrBuChanged || this.isJobLocationChanged) {
                    stepDataHasChangedFlag = true;
                }
                if (!(_.isEqual(this.step2DetailsTempObject.workLocationIds, currentStep2DataObject.workLocationIds)) ||
                    !(_.isEqual(this.step2DetailsTempObject.sponsorships, currentStep2DataObject.sponsorships)) || this.isJobLocationChanged) {
                    this.isAsyncProcess = true;
                }
                break;
            case 3:
                let currentWorkflowStepsObject = {
                    jobId: this.job.id,
                    score: this.job.score,
                    autoMatch: this.job.autoMatch,
                    recruiterScreening: this.job.recruiterScreening,
                    techAssessmentId: this.job.techAssessmentId,
                    techAssessmentScore: this.job.techAssessmentScore,
                    techAssessment: this.job.techAssessment,
                    valueAssessmentId: this.job.valueAssessmentId,
                    valueAssessment: this.job.valueAssessment,
                    eduVerification: this.job.eduVerification,
                    expVeification: this.job.expVeification,
                    phoneScreen: this.job.phoneScreen,
                    interview: this.job.interview,
                    imageProctoring: this.job.imageProctoring,
                    addProctoringImagesToReport: this.job.addProctoringImagesToReport,
                    workflowStepsOrder: angular.copy(this.job.workflowStepsOrder),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    // jobBoardDetails: angular.copy(this.job.jobBoardDetails),
                    // resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
                    tab: "WORKFLOW_STEPS"
                };
                stepDataHasChangedFlag = !(angular.equals(this.workflowStepsTempObject, currentWorkflowStepsObject)) || !this.isLicensePreferenceSet;
                ;
                break;
            case 4:
                let currentJobBoardsSettingsObject = {
                    // jobId: this.job.id,
                    // autoMatch: this.job.autoMatch,
                    jobBoardDetails: angular.copy(this.job.jobBoardDetails),
                    resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
                    isResumePullEnabled: this.job.isResumePullEnabled,
                    radius: this.job.radius,
                    recency: this.job.recency,
                    tab: "JOB_BOARDS"
                };
                stepDataHasChangedFlag = !(angular.equals(this.jobBoardsSettingsTempObject, currentJobBoardsSettingsObject)) || (this.job.isResumePullEnabled);
                if (!this.isJobBoardDetailsSet)
                    stepDataHasChangedFlag = true;
                break;
            case 5:
                //do nothing
                break;
            case 6:
                let adjustedScore = $('.slider-adjust-4dot5-score').val();
                if (this.isInitialStateDraft || adjustedScore != this.job.score) {
                    stepDataHasChangedFlag = true;
                }
                break;
            default:
                break;
        }
        return stepDataHasChangedFlag;
    }
    _enableStepActionsOnWizard(currentStep) {
        switch (currentStep) {
            case 1:
                this.step1RequestWasInProgressFlag = false;
                break;
            case 2:
                this.step2RequestWasInProgressFlag = false;
                break;
            case 3:
                this.step3RequestWasInProgressFlag = false;
                break;
            case 4:
                this.step4RequestWasInProgressFlag = false;
                break;
            case 5:
                this.step5RequestWasInProgressFlag = false;
                break;
            case 6:
                this.step5RequestWasInProgressFlag = false;
                break;
            default:
                break;
        }
        this.disableAllButtonsFlag = false;
    }
    wizardSaveStepData(clickedButton) {
        let currentStep = $('#uploadReqWizard').wizard('selectedItem').step;
        this._parseWorkflowStepsOrderBeforeSave();
        if (this.currentJobStatus !== 'DRAFT') {
            //step 6 is the last step
            if (currentStep == 5) {
                currentStep = 6;
            }
        }
        if (this._isStepDataValid(currentStep)) {
            if (this._hasStepDataChanged(currentStep) || (this.currentJobStatus == 'DRAFT' && currentStep == 5 && this.isActivateRequisitionEnabled) || (currentStep == 6 && this.isWorkFlowStep4Dot5ScoreChanged)) {
                switch (currentStep) {
                    case 1:
                        if (this.currentJobStatus == 'DRAFT' && !this.job.id) {
                            this.createRequisitionWithouFile(() => {
                                if (!this.editModeFlag) {
                                    this.getRecruiters(() => {
                                        this._setRecruitersAndHiringManagers();
                                    });
                                    if (!this.isCorporate) {
                                        this.getPointOfContacts(() => {
                                            this._setPocs();
                                        });
                                    }
                                    if (!this.clientOrBUIsRequiredFlag) {
                                        this.getBuVendors(() => {
                                            this._setBuVendors();
                                        });
                                    }
                                }
                            }, () => { });
                        }
                        else {
                            if (this.currentJobStatus == 'DRAFT') {
                                this._saveStep1(false, () => { }, () => { });
                            }
                            else {
                                this.alertsAndNotificationsService.showConfirm("Recalculate Score", "Re-calculate the scores now?", "warning", true, () => {
                                    this._saveStep1(true, () => {
                                        // this.reRunResumeScore(null, () => {});
                                        this.isRecalcucateScoreNoClicked = false;
                                    }, () => { });
                                }, () => {
                                    this._saveStep1(false, () => {
                                        this.isRecalcucateScoreNoClicked = true;
                                    }, () => { });
                                });
                            }
                        }
                        break;
                    case 2:
                        if (this._hasRecruitersBeingUnAssigned() || this._hasVendorsBeingUnAssigned()) {
                            if (this._hasRecruitersBeingUnAssigned() && this._hasVendorsBeingUnAssigned()) {
                                // show both warnings
                                let warningMessage = this._getAssignedRecruitersWarningMessage();
                                warningMessage = warningMessage + "<br><br>" + this._getVendorsRemovedWarningMessage();
                                this._showWarningMessage(warningMessage, () => {
                                    this._saveStep2('SAVE');
                                }, () => {
                                    this.job.vendorIds = angular.copy(this.step2DetailsTempObject.vendorIds);
                                    this._setBuVendors();
                                    this.job.recruiters = angular.copy(this.step2DetailsTempObject.recruiters);
                                    this._setRecruitersAndHiringManagers();
                                });
                            }
                            else if (this._hasVendorsBeingUnAssigned()) {
                                this._showVendorsRemovedWarning(() => {
                                    this._saveStep2('SAVE');
                                }, () => {
                                    this.job.vendorIds = angular.copy(this.step2DetailsTempObject.vendorIds);
                                    this._setBuVendors();
                                });
                            }
                            else {
                                this._showRecruitersUnAssignedWarning(() => {
                                    this._saveStep2('SAVE');
                                }, () => {
                                    this.job.recruiters = angular.copy(this.step2DetailsTempObject.recruiters);
                                    this._setRecruitersAndHiringManagers();
                                });
                            }
                        }
                        else {
                            this.disableAllButtonsFlag = true;
                            this.savingFlag = true;
                            this.utilityService.showLoadingModal("Saving...");
                            this.saveStep2Details('SAVE', () => {
                                this.utilityService.hideLoadingModal();
                                this.disableAllButtonsFlag = false;
                                this.savingFlag = false;
                                if (this.$rootScope.isOnline) {
                                    let successMessage = 'The Requisition details have been saved in Draft Status.';
                                    if (this.currentJobStatus == 'OPEN') {
                                        successMessage = 'The Requisition details have been saved.';
                                    }
                                    this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                                }
                                this._createStepTempObject(currentStep);
                            }, (error) => {
                                this.utilityService.hideLoadingModal();
                                this.disableAllButtonsFlag = false;
                                this.savingFlag = false;
                                if (this.$rootScope.isOnline) {
                                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                }
                            });
                        }
                        break;
                    case 3:
                        if (this.currentJobStatus == 'DRAFT') {
                            this._updateDataAfterWorkflowStepsSaved(false, currentStep, () => { }, () => { });
                        }
                        else {
                            if (this.hasMatchingMandatoryCriteriaChanged() || this.hasMissingPreferenceDetailsChanged()) {
                                this.alertsAndNotificationsService.showConfirm("Recalculate Score", "Re-calculate the scores now?", "warning", true, () => {
                                    this._updateDataAfterWorkflowStepsSaved(true, currentStep, () => {
                                        // this.reRunResumeScore(null, () => { });
                                    }, () => { });
                                }, () => {
                                    this._updateDataAfterWorkflowStepsSaved(false, currentStep, () => {
                                        this.isRecalcucateScoreNoClicked = true;
                                    }, () => { });
                                });
                            }
                            else {
                                this._updateDataAfterWorkflowStepsSaved(false, currentStep, () => { }, () => { });
                            }
                        }
                        break;
                    case 4:
                        this.disableAllButtonsFlag = true;
                        this.savingFlag = true;
                        this.saveJobBoardsSettings('SAVE', () => {
                            this.disableAllButtonsFlag = false;
                            this.savingFlag = false;
                            let successMessage = "";
                            // show the message that the job is saved state
                            if (this.$rootScope.isOnline) {
                                if (this.currentJobStatus == 'OPEN') {
                                    successMessage = "All the parameters have been saved. ";
                                    if (this.job.isResumePullEnabled) {
                                        successMessage = successMessage + "Only when you click ‘Next’ will more resumes be pulled ";
                                        if (this.job.autoMatch) {
                                            successMessage = successMessage + "and matched from job boards.";
                                        }
                                    }
                                    else {
                                        if (this.job.autoMatch) {
                                            successMessage = successMessage + "Only when you click ‘Next’ candidates will be matched.";
                                        }
                                    }
                                }
                                if (this.currentJobStatus == 'DRAFT') {
                                    successMessage = "All the parameters have been saved. Requisition is in Draft Status. Only when you hit 'Next' will the status be changed to 'Open'. ";
                                    if (this.job.autoMatch) {
                                        successMessage = successMessage + "Matching of candidates to requisition will also happen only when you hit 'Next'.";
                                    }
                                }
                                this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                            }
                            // this.jobBoardDetailsCopy = angular.copy(this.job.jobBoardDetails);
                            this._createStepTempObject(currentStep);
                        }, (error) => {
                            this.disableAllButtonsFlag = false;
                            this.savingFlag = false;
                            if (this.$rootScope.isOnline) {
                                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            }
                        });
                        break;
                    case 5:
                        this.step5RequestWasInProgressFlag = true;
                        this._setJobStateToOpenAndRunForScoring(() => {
                            let message = "Requisition activation process has started in the background and will inform all users on the Requisition when its completed.";
                            this.alertsAndNotificationsService.showAlertWithCallBack("Requisition Activation", message, "success", () => {
                                this.$state.go('missioncontrol.requisitions');
                            });
                        }, () => { });
                        break;
                    case 6:
                        this.disableAllButtonsFlag = true;
                        this.savingFlag = true;
                        let adjustedScore = $('.slider-adjust-4dot5-score').val();
                        this.saveAdjusted4dot5Score(adjustedScore, (data) => {
                            this.isWorkFlowStep4Dot5ScoreChanged = false;
                            this.disableAllButtonsFlag = false;
                            this.savingFlag = false;
                            // show the message that the score is updated
                            if (this.$rootScope.isOnline) {
                                let successMessage = 'The Job Match Score has been updated.';
                                this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                            }
                        }, (error) => {
                            this.disableAllButtonsFlag = false;
                            this.savingFlag = false;
                            if (this.$rootScope.isOnline) {
                                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            }
                        });
                        break;
                    default:
                        break;
                }
            }
            else {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage('Nothing to be saved!', 'info');
                }
            }
        }
    }
    isPrimaryHiringManagerSelected() {
        let managers = _.filter(this.job.hiringManagers, (manager) => {
            return manager.isPrimary == true;
        });
        if (managers.length > 0) {
            return true;
        }
        return false;
    }
    validateStepOne() {
        this.$timeout(() => {
            if (this.forms.step1Form && this.forms.step1Form.$submitted) {
                if (!this.req.clientOrBU || !this.sharedClientBuOrCorp) {
                    this.step1Error.hasErrorFlag = true;
                    this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                }
                else {
                    this.step1Error.hasErrorFlag = false;
                    this.step1Error.errorMessage = '';
                }
            }
        }, 100);
    }
    validateStepTwo() {
        this.$timeout(() => {
            if (this.forms.step2Form && this.forms.step2Form.$submitted) {
                if (this.forms.step2Form.$invalid || (this.job.jobType == null) || (this.job.recruiters.length == 0) || (this.job.sponsorshipProvided && this.job.sponsorships.length == 0) || (this.job.hiringManagers.length > 0 && !this.isPrimaryHiringManagerSelected()) || (this.job.vendorIds.length > 0 && _.isNull(this.job.pointOfContactUserId))) {
                    this.step2Error.hasErrorFlag = true;
                    this.step2Error.errorMessage = 'Please enter all mandatory fields.';
                }
                else {
                    this.step2Error.hasErrorFlag = false;
                    this.step2Error.errorMessage = '';
                }
            }
        }, 100);
    }
    validateStepThree() {
        this.$timeout(() => {
            if (this.forms.step3Form.$submitted && this.forms.step3Form.$invalid) {
                this.step3Error.hasErrorFlag = true;
                this.step3Error.errorMessage = 'Please enter all mandatory fields.';
            }
            else {
                this.step3Error.hasErrorFlag = false;
                this.step3Error.errorMessage = '';
            }
        }, 100);
    }
    wizardCancel() {
        let currentStep = $("#uploadReqWizard").wizard('selectedItem');
        if (this._hasStepDataChanged(currentStep.step)) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    if (result) {
                        this.resetStepData(currentStep.step, () => {
                            this.$state.go('missioncontrol.requisitions');
                        });
                        if (this.isRecalcucateScoreNoClicked) {
                            this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => { });
                        }
                    }
                }
            });
        }
        else {
            if (this.isRecalcucateScoreNoClicked) {
                this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => {
                    this.$state.go('missioncontrol.requisitions');
                });
            }
            else {
                this.$state.go('missioncontrol.requisitions');
            }
        }
    }
    resetStepData(step, successCallback) {
        this.$timeout(() => {
            switch (step) {
                case 1:
                    this.isStepOneActive = false;
                    this.job.id = this.step1DetailsTempObject.jobId;
                    this.job.title = this.step1DetailsTempObject.title;
                    if (this.currentJobStatus !== 'DRAFT') {
                        this.job.isSharedClientRequisition = this.step1DetailsTempObject.isSharedClientRequisition;
                        this.job.sharedClientBuOrCorpId = this.step1DetailsTempObject.sharedClientBuOrCorpId;
                    }
                    else {
                        this.req.isSharedClientRequisition = this.step1DetailsTempObject.isSharedClientRequisition;
                        this.req.sharedClientBuOrCorpId = this.step1DetailsTempObject.sharedClientBuOrCorpId;
                    }
                    this.job.requisitionNumber = this.step1DetailsTempObject.requisitionNumber;
                    this.isFutureMatchesOnly = this.step1DetailsTempObject.isFutureMatchesOnly;
                    this.job.profileCriteriaInfo = this.step1DetailsTempObject.profileCriteriaInfo;
                    this.job.includeCandidatesWithNoAdditionalDetails = this.step1DetailsTempObject.includeCandidatesWithNoAdditionalDetails;
                    this.job.includeCandidatesMatchingMandatoryCriteria = this.step1DetailsTempObject.includeCandidatesMatchingMandatoryCriteria;
                    //do nothing
                    break;
                case 2:
                    this.isStepOneActive = false;
                    this.job.title = this.step2DetailsTempObject.title;
                    this.job.isSharedClientRequisition = this.step2DetailsTempObject.isSharedClientRequisition;
                    this.job.sharedClientBuOrCorpId = this.step2DetailsTempObject.sharedClientBuOrCorpId;
                    if (_.isNull(this.step2DetailsTempObject.clientOrBUId)) {
                        this.job.clientorbu = null;
                    }
                    else {
                        angular.forEach(this.clientorbulist, (val, key) => {
                            if (val.id == this.step2DetailsTempObject.clientOrBUId) {
                                this.job.clientorbu = val;
                            }
                        });
                    }
                    this.job.requisitionNumber = this.step2DetailsTempObject.requistionNumber;
                    this.job.openings = this.step2DetailsTempObject.openings;
                    this.job.jobType = this.step2DetailsTempObject.jobType;
                    this.job.contractDuration = this.step2DetailsTempObject.contractDuration;
                    this.job.requisitionNote = this.step2DetailsTempObject.requisitionNote;
                    this.job.jobSalary = angular.copy(this.step2DetailsTempObject.jobSalary);
                    this._setJobType();
                    this.job.sponsorships = this.step2DetailsTempObject.sponsorships;
                    this.job.sponsorshipProvided = this.step2DetailsTempObject.sponsorshipProvided;
                    this._setSponsorshipType();
                    this.job.workLocationIds = this.step2DetailsTempObject.workLocationIds;
                    this._setWorkLocations();
                    this.job.recruiters = this.step2DetailsTempObject.recruiters;
                    this.job.hiringManagers = angular.copy(this.step2DetailsTempObject.hiringManagers);
                    this.job.vendorIds = this.step2DetailsTempObject.vendorIds;
                    this.job.salary = this.step2DetailsTempObject.salary;
                    this._setRecruitersAndHiringManagers();
                    this._setBuVendors();
                    break;
                case 3:
                    this.job.score = this.workflowStepsTempObject.score;
                    $('.slider-intelligence').val(this.job.score);
                    $('#4dot5IntelligenceScoreDisplayValue').text(this.job.score);
                    this.job.autoMatch = this.workflowStepsTempObject.autoMatch;
                    this.job.recruiterScreening = this.workflowStepsTempObject.recruiterScreening;
                    this.job.techAssessmentId = this.workflowStepsTempObject.techAssessmentId;
                    this.job.techAssessment = this.workflowStepsTempObject.techAssessment;
                    this.job.techAssessmentScore = this.workflowStepsTempObject.techAssessmentScore;
                    $('.slider-tech-assessment').val(this.job.techAssessmentScore);
                    $('#techAssessmentScoreDisplayValue').text(this.job.techAssessmentScore);
                    this.job.valueAssessment = this.workflowStepsTempObject.valueAssessment;
                    this.job.techAssessmentScore = this.workflowStepsTempObject.techAssessmentScore;
                    this.job.valueAssessmentId = this.workflowStepsTempObject.valueAssessmentId;
                    this.job.eduVerification = this.workflowStepsTempObject.eduVerification;
                    this.job.expVeification = this.workflowStepsTempObject.expVeification;
                    this.job.phoneScreen = this.workflowStepsTempObject.phoneScreen;
                    this.job.interview = this.workflowStepsTempObject.interview;
                    this.job.imageProctoring = this.workflowStepsTempObject.imageProctoring;
                    this.job.addProctoringImagesToReport = this.workflowStepsTempObject.addProctoringImagesToReport;
                    this.job.workflowStepsOrder = angular.copy(this.workflowStepsTempObject.workflowStepsOrder);
                    // this.job.jobBoardDetails = angular.copy(this.workflowStepsTempObject.jobBoardDetails);
                    // this.job.resumesToPullPerJobBoardCount = this.workflowStepsTempObject.resumesToPullPerJobBoardCount;
                    this.job.includeCandidatesWithNoAdditionalDetails = this.workflowStepsTempObject.includeCandidatesWithNoAdditionalDetails;
                    this.job.includeCandidatesMatchingMandatoryCriteria = this.workflowStepsTempObject.includeCandidatesMatchingMandatoryCriteria;
                    break;
                case 4:
                    this.job.jobBoardDetails = angular.copy(this.jobBoardDetailsCopy);
                    this.job.resumesToPullPerJobBoardCount = this.jobBoardsSettingsTempObject.resumesToPullPerJobBoardCount;
                    this.job.isResumePullEnabled = this.jobBoardsSettingsTempObject.isResumePullEnabled;
                    this.job.radius = this.jobBoardsSettingsTempObject.radius;
                    this.job.recency = this.jobBoardsSettingsTempObject.recency;
                    break;
                case 5:
                    //do nothing
                    break;
                case 6:
                    $('.slider-adjust-4dot5-score').val(this.job.score);
                    $('#adjust4dot5ScoreDisplayValue').text(this.job.score);
                    this.getCandidateCount(this.job.score, 'adjustedScore');
                    break;
                default:
                    break;
            }
            if (successCallback) {
                successCallback();
            }
        }, 100);
    }
    getJobScoringJobStatus() {
        this.jobService.getJobScoringJobStatus(this.job.id, data => {
            this.scoringInProgress = data;
            if (this.scoringInProgress) {
                let message = "Job matching process is in progress and will inform all users on the Requisition when its completed.";
                this.alertsAndNotificationsService.showAlertWithCallBack("Job matching in Progress", message, "success", () => {
                    this.$state.go('missioncontrol.requisitions');
                });
            }
        }, error => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    /**
     * this function fetches all client or bu list from service
     */
    getAllClientsOrBu(successCallback) {
        let requisitionId = _.isNull(this.job.id) ? null : this.job.id;
        let isFromCreateReq = false;
        if (!requisitionId) {
            isFromCreateReq = true;
        }
        this.requisitionService.getAllClientsOrBu(this.userDetails, requisitionId, isFromCreateReq, (data) => {
            this.clientorbulist = data;
            angular.forEach(this.clientorbulist, (clientOrBu, key) => {
                if (clientOrBu.companyType == 'Corporation') {
                    clientOrBu.displayName = clientOrBu.name + " &#xf1e0;";
                }
                else {
                    clientOrBu.displayName = clientOrBu.name;
                }
            });
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setClientOrBu(clientorbu) {
        if (!_.isNull(clientorbu)) {
            this.req.clientOrBU = {
                name: clientorbu.name,
                companyType: clientorbu.companyType,
                companyState: clientorbu.companyState,
                id: clientorbu.id,
                shortName: clientorbu.shortName
            };
        }
        else {
            this.req.clientOrBU = null;
        }
    }
    getAllJobTypes(successCallback) {
        this.jobService.getAllJobTypes((data) => {
            this.jobTypeList = data;
            this.job.jobTypeLabel = (this.job.jobType && this.jobTypeList.length > 0) ? this.jobTypeList.filter(jobType => jobType.value == this.job.jobType)[0].name : null;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getAllWorkLocations(successCallback) {
        this.jobService.getWorkLocations((data) => {
            this.workLocationsList = data.filter(location => location.name !== "No Work Location");
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    onClientOrBuChanged() {
        let clientOrBusWithoutNoAssociatedBus = this.clientorbulist.filter(clientOrBu => clientOrBu.id !== "");
        let selectedClientOrBu = _.find(clientOrBusWithoutNoAssociatedBus, { id: this.job.clientorbu.id });
        this.job.clientorbu = angular.copy(selectedClientOrBu);
        this.req.clientOrBU = angular.copy(selectedClientOrBu);
        this.editBUFlag = !this.editBUFlag;
        this.job.recruiters = [];
        this.job.hiringManagers = [];
        this.job.vendorIds = [];
        this.job.pointOfContactUserId = null;
        // get recruiters
        this.getRecruiters(() => {
            this._setRecruitersAndHiringManagers();
        });
        //get bu vendors
        if (!this.clientOrBUIsRequiredFlag) {
            this.getBuVendors(() => {
                this._setBuVendors();
            });
        }
        //get shared client bus
        if (this.job.clientorbu && this.job.clientorbu.companyType == 'Corporation') {
            this.req.isSharedClientRequisition = true;
            this.job.isSharedClientRequisition = true;
            this._getSharedClientBus();
        }
        else {
            this.req.isSharedClientRequisition = false;
            this.job.isSharedClientRequisition = false;
            this.req.sharedClientBuOrCorpId = null;
            this.job.sharedClientBuOrCorpId = null;
            this.sharedCorporateId = null;
            this.sharedClientBuOrCorp = {};
        }
        this.getAllJobBoards(() => {
            this._setJobBoardDetails();
        });
    }
    onJobTypeSelected(multiSelectAction) {
        if (this.selectedJobTypes.length > 0) {
            if (!this.candidatesPresentOnJob) {
                this.job.jobType = this.selectedJobTypes[0].value;
                if (this.job.jobType !== "CONTRACTOR" && this.job.jobType !== "CONTRACTTOHIRE") {
                    this.job.contractDuration = null;
                }
                this.hasJobTypeChanged = true;
                this.isJobTypeChanged = true;
                this._massageWorkflowStepsOrder();
            }
            else if (multiSelectAction == 'close') {
                this._showcandidatesPresentOnJobWarningMessage(() => {
                    this._setJobType();
                });
            }
        }
        else {
            this.job.jobType = null;
        }
        this.validateStepTwo();
    }
    onPocSelected() {
        if (this.selectedPocs.length > 0) {
            this.job.pointOfContactUserId = this.selectedPocs[0].userId;
        }
        else {
            this.job.pointOfContactUserId = null;
        }
        this.validateStepTwo();
    }
    _setJobType() {
        if (angular.isDefined(this.job.jobType)) {
            for (let k = 0; k < this.jobTypeList.length; k++) {
                if (this.job.jobType === this.jobTypeList[k].value) {
                    this.jobTypeList[k].selected = true;
                }
                else {
                    this.jobTypeList[k].selected = false;
                }
            }
        }
        else {
            for (let i = 0; i < this.jobTypeList.length; i++) {
                this.jobTypeList[i].selected = false;
            }
        }
        let selectedJobTypeArray = _.filter(this.jobTypeList, (jobType) => {
            return jobType.value == this.job.jobType;
        });
        if (selectedJobTypeArray.length > 0) {
            this.selectedJobType = selectedJobTypeArray[0].name;
        }
        else {
            this.selectedJobType = null;
        }
        this._setSalaryLabel();
    }
    _setSalaryLabel() {
        if (this.selectedJobType == 'Contractor' || this.selectedJobType == 'Contract to Hire') {
            this.salaryLabel = this.isCorporate ? "Bill Rate" : "Client/Bill Rate";
        }
        else {
            this.salaryLabel = 'Salary';
        }
        this._setSalaryRangeOptions();
    }
    _setSalaryRangeOptions() {
        if (this.selectedJobType) {
            if (this.selectedJobType !== 'Full Time') {
                // Bill Rate: exclude PER_YEAR, default to PER_HOUR (By Hour)
                this.salaryDurationOptions = this.allSalaryDurationOptions.filter((salaryDuration) => salaryDuration.value != 'PER_YEAR');
                if (!this.isJobTypeChanged) {
                    // If existing saved duration is PER_YEAR (legacy data), show all options to avoid blank dropdown
                    if (this.job.jobSalary && this.job.jobSalary.salaryDuration === 'PER_YEAR') {
                        this.salaryDurationOptions = [...this.allSalaryDurationOptions];
                    }
                }
                else {
                    // User actively changed job type — always default to PER_HOUR
                    if (!this.job.jobSalary) {
                        this.job.jobSalary = new JobSalary();
                        this.job.jobSalary.currency = 'USD';
                    }
                    this.job.jobSalary.salaryDuration = 'PER_HOUR';
                }
            }
            else {
                // Salary (Full Time and all other job types): only PER_YEAR, default to PER_YEAR (By Year)
                this.salaryDurationOptions = this.allSalaryDurationOptions.filter((salaryDuration) => salaryDuration.value === 'PER_YEAR');
                if (this.job.jobSalary) {
                    this.job.jobSalary.salaryDuration = 'PER_YEAR';
                }
            }
        }
        else {
            this.salaryDurationOptions = [...this.allSalaryDurationOptions];
        }
    }
    getAllSponsorshipTypes(successCallback) {
        this.jobService.getAllSponsorshipTypes((data) => {
            this.sponsorshipList = data.filter(sponsorship => sponsorship.value != 'NO_WORK_AUTHORIZATION_SPECIFIED');
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setSponsorshipType() {
        if (this.sponsorshipList) {
            if (this.job.sponsorships) {
                this.selectedSponsorships = angular.copy(this.job.sponsorships);
                angular.forEach(this.sponsorshipList, (val, key) => {
                    if (this.job.sponsorships.indexOf(val.value) > -1) {
                        val.selected = true;
                    }
                    else {
                        val.selected = false;
                    }
                });
            }
        }
    }
    onSponsorshipProvidedSelected() {
        if (!this.job.sponsorshipProvided) {
            this._setSponsorshipSelectedDefault(true);
            this.validateStepTwo();
        }
    }
    _setSponsorshipSelectedDefault(sponsorshipChanged) {
        if ((this.sponsorshipList && _.isNull(this.job.sponsorships)) || sponsorshipChanged) {
            this.selectedSponsorships = ['CITIZENONLY', 'PERMANENTRESIDENTORGREENCARD'];
            angular.forEach(this.sponsorshipList, (val, key) => {
                val.selected = this.selectedSponsorships.indexOf(val.value) > -1 ? true : false;
            });
            this.job.sponsorships = angular.copy(this.selectedSponsorships);
        }
    }
    onWorkLocationsSelected() {
        this.job.workLocationIds = [];
        if (this.selectedWorkLocationsList.length > 0) {
            this.selectedWorkLocationsList.forEach(workLocation => {
                this.job.workLocationIds.push(workLocation.id);
            });
        }
    }
    _setWorkLocations() {
        if (this.job.workLocationIds) {
            this.workLocationsList.forEach(workLocation => {
                workLocation.selected = this.job.workLocationIds.indexOf(workLocation.id) > -1;
            });
        }
    }
    onSponsorshipSelected(index, sponsorship) {
        this.job.sponsorships = [];
        if (sponsorship.selected === true) {
            this.selectedSponsorships.push(sponsorship.value);
        }
        else {
            this.selectedSponsorships = this.selectedSponsorships.filter(item => item != sponsorship.value);
        }
        this.job.sponsorships = angular.copy(this.selectedSponsorships);
        this.validateStepTwo();
    }
    onAssessmentChange(assessmentType) {
        if (assessmentType == 'Technical' && this.job.techAssessmentId !== this.workflowStepsTempObject.techAssessmentId && this.sentTechnicalAssessmentsDetail.count > 0) {
            this._showCancelAssessmentsConfirmation(assessmentType);
        }
        else if (assessmentType == 'Value' && this.job.valueAssessmentId !== this.workflowStepsTempObject.valueAssessmentId && this.sentValueAssessmentsDetail.count > 0) {
            this._showCancelAssessmentsConfirmation(assessmentType);
        }
    }
    _showCancelAssessmentsConfirmation(assessmentType) {
        let message = "";
        let assessmentsCount = assessmentType == 'Technical' ? this.sentTechnicalAssessmentsDetail.count : this.sentValueAssessmentsDetail.count;
        message = "There are " + assessmentsCount + " " + assessmentType + " assessments that have already been sent out using the previous assessment. Do you want to cancel it? Cancellation notices will be sent out. This action cannot be undone!";
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cancel Sent Assessments!</strong></div>",
            message: message,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this.cancelSentAssessments(assessmentType);
                }
                else {
                    this._resetAssessmentId(assessmentType);
                }
            }
        });
    }
    _resetAssessmentId(assessmentType) {
        if (assessmentType == 'Technical') {
            this.job.techAssessmentId = this.workflowStepsTempObject.techAssessmentId;
        }
        else {
            this.job.valueAssessmentId = this.workflowStepsTempObject.valueAssessmentId;
        }
    }
    cancelSentAssessments(assessmentType) {
        let candidateAssessmentIds = [];
        if (assessmentType == "Technical") {
            candidateAssessmentIds = this.sentTechnicalAssessmentsDetail.candidateAssessmentIds;
        }
        else {
            candidateAssessmentIds = this.sentValueAssessmentsDetail.candidateAssessmentIds;
        }
        this.candidateService.cancelSentAssessments(candidateAssessmentIds, this.companyId, (data) => {
            this.alertsAndNotificationsService.showBannerMessage('All the assessments that were sent to candidates have been cancelled successfully', 'success');
            this.sentTechnicalAssessmentsDetail = new SentAssessmentDetail();
            this.sentValueAssessmentDetail = new SentAssessmentDetail();
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAllTechAssessments(successCallback) {
        let clientOrBuId = null;
        let isJobWorkflow = true;
        if (this.job.clientorbu) {
            clientOrBuId = this.job.clientorbu.id;
        }
        this.assessmentService.getAllTechAssessments(this.companyId, clientOrBuId, isJobWorkflow, (data) => {
            this.techAssessmentList = data;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (successCallback) {
                successCallback();
            }
        });
    }
    getAllValueAssessments(successCallback) {
        let clientOrBuId = null;
        let isJobWorkflow = true;
        if (this.job.clientorbu) {
            clientOrBuId = this.job.clientorbu.id;
        }
        this.assessmentService.getAllValueAssessments(this.companyId, clientOrBuId, isJobWorkflow, (data) => {
            if (data.length > 0) {
                this.valueAssessmentList = data;
            }
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (successCallback) {
                successCallback();
            }
        });
    }
    getAllJobBoards(successCallback) {
        let buId = null;
        if (this.job.clientorbu && this.isCorporate) {
            buId = this.job.clientorbu.id;
        }
        this.resumeService.getResumeSourceTypes(this.companyId, buId, (data) => {
            if (data.length > 0) {
                this.isJobBoardSelected = true;
                angular.forEach(data, (val, key) => {
                    val.boardId = val.id;
                    val.enabled = true;
                    delete val.id;
                });
                if (successCallback) {
                    successCallback();
                }
            }
            this.jobBoardDetails = data;
            this.job.jobBoardDetails = angular.copy(this.jobBoardDetails);
            this.jobBoardDetailsCopy = angular.copy(this.job.jobBoardDetails);
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setJobBoardDetails() {
        this.job.jobBoardDetails = angular.copy(this.jobBoardDetails);
        if (!_.isNull(this.job.licensePreferences) && !_.isNull(this.job.licensePreferences.jobBoardDetails)) {
            angular.forEach(this.job.jobBoardDetails, (val, key) => {
                if (_.findIndex(this.job.licensePreferences.jobBoardDetails, { 'boardId': val.boardId, 'enabled': true }) == -1) {
                    val.enabled = false;
                }
            });
        }
        angular.forEach(this.job.jobBoardDetails, (val, key) => {
            if (val.enabled == true) {
                this.isJobBoardSelected = true;
                console.log(this.isJobBoardSelected);
            }
        });
        this.jobBoardDetailsCopy = angular.copy(this.job.jobBoardDetails);
    }
    getRecruiters(successCallback) {
        let clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        let requisitionId = _.isNull(this.job.id) ? null : this.job.id;
        let clientOrBuIds = [];
        let requisitionNumbers = [];
        let isUploadOrEditReq = true;
        this.jobService.getAllRecruiters(this.userDetails, this.userDetails.company, clientOrBUId, requisitionId, clientOrBuIds, requisitionNumbers, isUploadOrEditReq, (data) => {
            this.recruiterList = data.recruiters;
            this.hiringManagerList = data.hiringManagers;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getPointOfContacts(successCallback) {
        let clientOrBUId = this.job.isSharedClientRequisition ? this.job.sharedClientBuOrCorpId : this.job.clientorbu.id;
        let corporateId = this.sharedCorporateId;
        if (corporateId == clientOrBUId) {
            clientOrBUId = null;
        }
        this.companyService.getClientOrBuPocs(corporateId, clientOrBUId, (data) => {
            this.pocs = data;
            angular.forEach(this.pocs, (poc) => {
                poc.userId = poc.id;
            });
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getBuVendors(successCallback) {
        let buId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        this.jobService.getBuVendors(this.userDetails.company.companyId, buId, (data) => {
            this.vendorsList = data;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    onRecruitersSelected() {
        this.job.recruiters = [];
        if (this.selectedRecruiters.length > 0) {
            angular.forEach(this.selectedRecruiters, (recruiter, key) => {
                this.job.recruiters.push(recruiter.userId);
            });
        }
        this.validateStepTwo();
        if (this.isCorporate) {
            this._setPoc();
        }
    }
    onHiringManagersSelected() {
        this.job.hiringManagers = [];
        if (this.selectedHiringManagers.length !== 0 && this.selectedHiringManagers.length > 1) {
            angular.forEach(this.selectedHiringManagers, (hiringManager, key) => {
                hiringManager.isPrimary = hiringManager.userId === this.primaryHiringManagerId ? true : false;
                this.job.hiringManagers.push({ id: hiringManager.userId, isPrimary: hiringManager.isPrimary });
            });
            this.primaryHiringManagerList = angular.copy(this.selectedHiringManagers);
        }
        else if (this.selectedHiringManagers.length == 1) {
            this.primaryHiringManagerId = this.selectedHiringManagers[0].userId;
            this.selectedHiringManagers[0].isPrimary = true;
            this.job.hiringManagers.push({ id: this.selectedHiringManagers[0].userId, isPrimary: this.selectedHiringManagers[0].isPrimary });
            this.primaryHiringManagerList = angular.copy(this.selectedHiringManagers);
        }
        if (this.isCorporate) {
            this._setPoc();
        }
    }
    onPrimaryHiringManagerSelected(selectedHiringManager) {
        angular.forEach(this.job.hiringManagers, (manager, key) => {
            if (manager.id == selectedHiringManager.userId) {
                manager.isPrimary = true;
                this.primaryHiringManagerId = manager.id;
            }
            else {
                manager.isPrimary = false;
            }
        });
        angular.forEach(this.primaryHiringManagerList, (manager, key) => {
            if (manager.userId == selectedHiringManager.userId) {
                manager.isPrimary = true;
            }
            else {
                manager.isPrimary = false;
            }
        });
        this.validateStepTwo();
        if (this.isCorporate) {
            this._setPoc();
        }
    }
    onVendorsSelected() {
        this.job.vendorIds = [];
        if (this.selectedVendors.length > 0) {
            angular.forEach(this.selectedVendors, (vendor, key) => {
                this.job.vendorIds.push(vendor.vendorId);
            });
        }
        this.validateStepTwo();
    }
    _setRecruitersAndHiringManagers() {
        angular.forEach(this.recruiterList, (val, key) => {
            if (this.job.recruiters.indexOf(val.userId) > -1) {
                val.selected = true;
            }
            else {
                val.selected = false;
            }
        });
        angular.forEach(this.hiringManagerList, (val, key) => {
            let managers = _.filter(this.job.hiringManagers, (manager) => {
                return manager.id == val.userId;
            });
            if (managers.length > 0) {
                val.selected = true;
                val.isPrimary = managers[0].isPrimary;
                if (val.isPrimary) {
                    this.primaryHiringManagerId = val.userId;
                }
            }
            else {
                val.selected = false;
            }
        });
        this.primaryHiringManagerList = _.filter(this.hiringManagerList, (manager) => { return manager.selected == true; });
        if (this.isCorporate) {
            this._setPoc();
        }
    }
    _setPocs() {
        angular.forEach(this.pocs, (poc, key) => {
            if (this.job.pointOfContactUserId == poc.userId) {
                poc.selected = true;
            }
            else {
                poc.selected = false;
            }
        });
    }
    _setPoc() {
        this.sharedJobPocs = [];
        //get all selected recruiters
        let pocs = _.filter(this.recruiterList, (recruiter) => {
            return recruiter.selected == true;
        });
        //get primary hiring manager
        angular.forEach(this.primaryHiringManagerList, (hiringManager, key) => {
            if (hiringManager.isPrimary) {
                pocs.push(hiringManager);
            }
        });
        this.sharedJobPocs = angular.copy(pocs);
        //check selected poc
        angular.forEach(this.sharedJobPocs, (poc, key) => {
            poc.selected = false;
            if (poc.userId == this.job.pointOfContactUserId) {
                poc.selected = true;
            }
        });
    }
    _setBuVendors() {
        if (!this.job.vendorIds) {
            this.job.vendorIds = [];
        }
        angular.forEach(this.vendorsList, (vendor, key) => {
            if (this.job.vendorIds.indexOf(vendor.vendorId) > -1) {
                vendor.selected = true;
            }
            else {
                vendor.selected = false;
            }
        });
    }
    onTechAssessmentCheckboxClick() {
        if (this.job.techAssessment) {
            $('.slider-tech-assessment').removeAttr('disabled');
        }
        else {
            $('.slider-tech-assessment').attr('disabled', true);
        }
    }
    onImageProctoringCheckboxClick() {
        if (!this.job.imageProctoring) {
            this.job.addProctoringImagesToReport = false;
        }
    }
    getLicensePreferences(successCallback, errorCallback) {
        this.jobService.getLicensePreferences(this.userDetails.company, this.job.clientorbu, this.job.id, (data) => {
            this.licensePreferenceDetails = data;
            if (_.isNull(this.job.licensePreferences) || _.isNull(this.job.licensePreferences.resumesToPullPerJobBoardCount)) {
                this.job.resumesToPullPerJobBoardCount = this.licensePreferenceDetails.resumesToPullPerJobBoardCount;
                this.resumesToPullPerJobBoardCountCopy = this.job.resumesToPullPerJobBoardCount;
                this.job.isResumePullEnabled = false;
                this.job.workflowStepsOrder = angular.copy(data.workflowStepsOrder);
            }
            if (this.currentJobStatus != 'DRAFT') {
                // Refresh requisition icons
                this.requisitionInfo.autoMatedMatchSelected = this.licensePreferenceDetails.autoMatch.licensePrefDetailsList[0].enabled && this.licensePreferenceDetails.autoMatch.licensePrefDetailsList[0].selected && (this.job.licensePreferences && this.job.licensePreferences.autoMatch);
            }
            successCallback();
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    _createWorkflowSliders(successCallback) {
        // empty the existing sliders
        $('.slider-intelligence').empty();
        $('.slider-tech-assessment').empty();
        $(document).ready(() => {
            angular.forEach(this.licensePreferenceDetails, (val, key) => {
                switch (key) {
                    case 'fourDotFiveIntellList':
                        this.intelligencePreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            value: val.licensePrefDetailsList[0].licensePrefMarkerValue,
                            company: val.licensePrefDetailsList[0].markerCompanyName
                        };
                        // if not in edit mode or if the score has not been set yet
                        if (!this.editModeFlag || _.isNull(this.job.score) || this.hasClientOrBuChanged) {
                            this.job.score = val.licensePrefDetailsList[0].licensePrefMarkerValue;
                        }
                        let sliderClass = '.slider-intelligence';
                        $(sliderClass).noUiSlider({
                            range: [0, 100],
                            start: [this.job.score],
                            handles: 1,
                            connect: 'lower',
                            step: 1,
                            slide: () => {
                                let val = $(sliderClass).val();
                                this.job.score = val;
                                $('#4dot5IntelligenceScoreDisplayValue').text(val).addClass('slider-bold');
                                this.isWorkFlowStep4Dot5ScoreChanged = true;
                            },
                            set: () => {
                                let val = $(sliderClass).val();
                                this.job.score = val;
                                $('#4dot5IntelligenceScoreDisplayValue').text(val).removeClass('slider-bold');
                            }
                        });
                        // set the value onto the intelligence score value span which displays the current value
                        $('#4dot5IntelligenceScoreDisplayValue').text(this.job.score);
                        break;
                    case 'techAssessmentList':
                        this.techAssessmentPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            value: val.licensePrefDetailsList[0].licensePrefMarkerValue,
                            company: val.licensePrefDetailsList[0].markerCompanyName,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (this.editModeFlag) {
                            if (this.techAssessmentPreferences.enabled) {
                                // in edit mode, if license preferences have already been defined and techAssessment value is true
                                if (!_.isNull(this.job.licensePreferences) && this.job.licensePreferences.techAssessment) {
                                    this.job.techAssessment = true;
                                    // tech assessment score can be null for older assessments - then set the value to 0
                                    if (_.isNull(this.job.techAssessmentScore)) {
                                        this.job.techAssessmentScore = 0;
                                    }
                                }
                                else {
                                    this.job.techAssessment = false;
                                    this.job.techAssessmentScore = 0;
                                    this.job.techAssessmentId = null;
                                }
                            }
                            else {
                                this.job.techAssessment = false;
                                this.job.techAssessmentScore = 0;
                                this.job.techAssessmentId = null;
                            }
                        }
                        else {
                            // in add mode, if enabled, set tech assessment to true and score to the default value
                            if (this.techAssessmentPreferences.enabled) {
                                this.job.techAssessment = true;
                                this.job.techAssessmentScore = val.licensePrefDetailsList[0].licensePrefMarkerValue;
                            }
                            else {
                                this.job.techAssessment = false;
                                this.job.techAssessmentScore = 0;
                                this.job.techAssessmentId = null;
                            }
                        }
                        let techSliderClass = '.slider-tech-assessment';
                        $(techSliderClass).noUiSlider({
                            range: [0, 100],
                            start: [this.job.techAssessmentScore],
                            handles: 1,
                            connect: 'lower',
                            step: 1,
                            slide: () => {
                                let val = $(techSliderClass).val();
                                this.job.techAssessmentScore = val;
                                $('#techAssessmentScoreDisplayValue').text(val).addClass('slider-bold');
                            },
                            set: () => {
                                let val = $(techSliderClass).val();
                                this.job.techAssessmentScore = val;
                                $('#techAssessmentScoreDisplayValue').text(val).removeClass('slider-bold');
                            }
                        });
                        // set the value onto the intelligence score value span which displays the current value
                        $('#techAssessmentScoreDisplayValue').text(this.job.techAssessmentScore);
                        if (!this.techAssessmentPreferences.enabled) {
                            $('.slider-tech-assessment').attr("disabled", "disabled");
                        }
                        break;
                    case 'valueAssessmentList':
                        this.valueAssessmentPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            value: val.licensePrefDetailsList[0].licensePrefMarkerValue,
                            company: val.licensePrefDetailsList[0].markerCompanyName,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (this.editModeFlag) {
                            if (this.valueAssessmentPreferences.enabled) {
                                // in edit mode, if valueAssessment value is true
                                if (!_.isNull(this.job.licensePreferences) && this.job.licensePreferences.valueAssessment) {
                                    this.job.valueAssessment = true;
                                }
                                else {
                                    this.job.valueAssessment = false;
                                    this.job.valueAssessmentId = null;
                                }
                            }
                            else {
                                this.job.valueAssessment = false;
                                this.job.valueAssessmentId = null;
                            }
                        }
                        else {
                            // in add mode, if enabled, set value assessment to true
                            if (this.valueAssessmentPreferences.enabled) {
                                this.job.valueAssessment = true;
                            }
                            else {
                                this.job.valueAssessment = false;
                                this.job.valueAssessmentId = null;
                            }
                        }
                        break;
                    case 'verificationList':
                        this.verificationPreferences = {};
                        angular.forEach(val.licensePrefDetailsList, (v, k) => {
                            switch (v['licensePrefEnum']) {
                                case 'EDUCATION_VERIFICATION':
                                    this.verificationPreferences.educationVerificationName = v.name;
                                    this.verificationPreferences.educationVerificationEnabled = (v.enabled && v.selected);
                                    this.verificationPreferences.educationVerificationMessage = v.message;
                                    this.verificationPreferences.isCandidatesPresentOnStepEducationVerification = v.candidatesPresentOnStep;
                                    this.verificationPreferences.candidatesPresentMessageEducationVerification = v.messageForCandidatePresent;
                                    if (this.verificationPreferences.educationVerificationEnabled) {
                                        // edit mode and license preferences have been defined already
                                        if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                            this.job.eduVerification = this.job.licensePreferences.educationVerification;
                                        }
                                        else {
                                            this.job.eduVerification = true;
                                        }
                                    }
                                    else {
                                        this.job.eduVerification = false;
                                    }
                                    break;
                                case 'EXPERIENCE_VERIFICATION':
                                    this.verificationPreferences.experienceVerificationName = v.name;
                                    this.verificationPreferences.experienceVerificationEnabled = (v.enabled && v.selected);
                                    this.verificationPreferences.experienceVerificationMessage = v.message;
                                    this.verificationPreferences.isCandidatesPresentOnStepExperienceVerification = v.candidatesPresentOnStep;
                                    this.verificationPreferences.candidatesPresentMessageExperienceVerification = v.messageForCandidatePresent;
                                    if (this.verificationPreferences.experienceVerificationEnabled) {
                                        if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                            this.job.expVeification = this.job.licensePreferences.experienceVerification;
                                        }
                                        else {
                                            this.job.expVeification = true;
                                        }
                                    }
                                    else {
                                        this.job.expVeification = false;
                                    }
                                    break;
                            }
                        });
                        break;
                    case 'phoneScreenList':
                        this.phoneScreenPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (this.phoneScreenPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                this.job.phoneScreen = this.job.licensePreferences.phoneScreen;
                            }
                            else {
                                this.job.phoneScreen = true;
                            }
                        }
                        else {
                            this.job.phoneScreen = false;
                        }
                        break;
                    case 'interviewList':
                        this.interviewPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (this.interviewPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                this.job.interview = this.job.licensePreferences.interview;
                            }
                            else {
                                this.job.interview = true;
                            }
                        }
                        else {
                            this.job.interview = false;
                        }
                        break;
                    case 'licenseAssessmentPreferences':
                        this.imageProctoringPreferences = {
                            name: 'Image Proctoring',
                            enabled: (val.imageProctoringEnabled && val.imageProctoring),
                            message: val.imageProctoringMessage,
                        };
                        this.addImagesToReportPreferences = {
                            name: 'Add Proctoring Images to Report',
                            enabled: (val.addProctoringImagesToReportEnabled && val.addProctoringImagesToReport),
                            message: val.addProctoringImagesToReportMessage
                        };
                        if (this.imageProctoringPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                this.job.imageProctoring = this.job.licensePreferences.imageProctoring;
                            }
                            else {
                                this.job.imageProctoring = true;
                            }
                        }
                        else {
                            this.job.imageProctoring = false;
                        }
                        if (this.addImagesToReportPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                this.job.addProctoringImagesToReport = this.job.licensePreferences.addProctoringImagesToReport;
                            }
                            else {
                                this.job.addProctoringImagesToReport = true;
                            }
                        }
                        else {
                            this.job.addProctoringImagesToReport = false;
                        }
                        break;
                    case 'recruiterScreening':
                        this.recruiterScreeningPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (this.recruiterScreeningPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                this.job.recruiterScreening = this.job.licensePreferences.recruiterScreening;
                            }
                            else {
                                this.job.recruiterScreening = true;
                            }
                        }
                        else {
                            this.job.recruiterScreening = false;
                        }
                        break;
                    case 'autoMatch':
                        let enabledFlag = val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected;
                        this.autoMatchingPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: enabledFlag,
                            message: val.licensePrefDetailsList[0].message
                        };
                        if (enabledFlag) {
                            // edit mode and license preferences have been defined already
                            if (this.editModeFlag && !_.isNull(this.job.licensePreferences)) {
                                if (!_.isNull(this.job.licensePreferences.autoMatch)) {
                                    this.job.autoMatch = this.job.licensePreferences.autoMatch;
                                }
                                else {
                                    this.job.autoMatch = false;
                                }
                            }
                            else {
                                this.job.autoMatch = true;
                                this.job.includeCandidatesMatchingMandatoryCriteria = true;
                            }
                        }
                        else {
                            this.job.autoMatch = false;
                        }
                    default:
                        break;
                }
                if (val !== null && val.licensePrefDetailsList !== undefined && val.licensePrefDetailsList[0].candidatesPresentOnStep) {
                    this.candidatesPresentOnJob = val.licensePrefDetailsList[0].candidatesPresentOnStep;
                }
            });
            if (successCallback) {
                successCallback();
            }
        });
    }
    _createCountSliders() {
        // empty the existing sliders
        $('.slider-current-4dot5-score').empty();
        $('.slider-adjust-4dot5-score').empty();
        // create the current score slider
        let currentScoreSliderClass = '.slider-current-4dot5-score';
        $(currentScoreSliderClass).noUiSlider({
            range: [0, 100],
            start: [this.job.score],
            handles: 1,
            connect: 'lower',
            step: 1,
            slide: () => {
                let val = $(currentScoreSliderClass).val();
                $(currentScoreSliderClass).next('span').text(val).addClass('slider-bold');
            },
            set: () => {
                let val = $(currentScoreSliderClass).val();
                //this.$scope.sliderIntelligenceValue = parseFloat(val);
                //this.$scope.requisitionDetails.licensePreferenceDetails.licensePreferenceDetails.fourDotFiveIntellList.licensePrefDetailsList[0].value = this.$scope.sliderIntelligenceValue;
                $(currentScoreSliderClass).next('span').text(val).removeClass('slider-bold');
            }
        });
        // set the current score value to the display span
        $('.slider-current-4dot5-score').next('span').text(this.job.score);
        // disable the current 4dot5 score slider.
        $('.slider-current-4dot5-score').attr("disabled", "disabled");
        // create the slider to adjust the score.
        let adjustSliderClass = '.slider-adjust-4dot5-score';
        $(adjustSliderClass).noUiSlider({
            range: [0, 100],
            start: [this.job.score],
            handles: 1,
            connect: 'lower',
            step: 1,
            slide: () => {
                let val = $(adjustSliderClass).val();
                $(adjustSliderClass).next('span').text(val).addClass('slider-bold');
                this.$timeout(() => {
                    this.loadingAdjustedCandidatesCountFlag = true;
                }, 50);
            },
            set: () => {
                let val = $(adjustSliderClass).val();
                $(adjustSliderClass).next('span').text(val).removeClass('slider-bold');
                this.getCandidateCount(val, 'adjustedScore');
            }
        });
        // set the current score value to the display span
        $(adjustSliderClass).next('span').text(this.job.score);
    }
    onClientChange() {
        let clientOrBusWithoutNoAssociatedBus = this.clientorbulist.filter(clientOrBu => clientOrBu.id !== "");
        let clientOrBUId = !this.req.clientOrBU ? '' : this.req.clientOrBU.id;
        let selectedClientOrBu = _.find(clientOrBusWithoutNoAssociatedBus, { id: clientOrBUId });
        this.req.clientOrBU = angular.copy(selectedClientOrBu);
        if (this.req.clientOrBU && this.req.clientOrBU.companyType == 'Corporation') {
            this.req.isSharedClientRequisition = true;
            this._getSharedClientBus();
        }
        else {
            this.req.isSharedClientRequisition = false;
            this.req.sharedClientBuOrCorpId = null;
            this.sharedCorporateId = null;
        }
        // change the job to empty object
        // this.job = new Job();
        this.updateActionButtons();
        this.validateStepOne();
    }
    onSharedClientChanged(tabNumber) {
        this.sharedCorporateId = this.req.clientOrBU.id;
        this.req.sharedClientBuOrCorpId = this.sharedClientBuOrCorp.id;
        this.job.sharedClientBuOrCorpId = this.sharedClientBuOrCorp.id;
        if (tabNumber == 2) {
            this.getPointOfContacts(() => {
                this._setPocs();
            });
        }
        this.updateActionButtons();
        this.validateStepOne();
    }
    _getSharedClientBus(successCallback) {
        this.isLoadingSharedClientBus = true;
        this.companyService.getSharedClientBus(this.companyId, this.req.clientOrBU.id, (data) => {
            this.sharedClientBus = data;
            if (this.req.clientOrBU && this.req.clientOrBU.companyType == 'Corporation') {
                let sharedClient = angular.copy(this.req.clientOrBU);
                sharedClient.name = 'None';
                sharedClient.companyType = 'Corporation';
                this.sharedClientBus.push(sharedClient);
                this._setSharedClientBu();
            }
            this.isLoadingSharedClientBus = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setSharedClientBu() {
        this.sharedClientBuOrCorp = _.find(this.sharedClientBus, { 'id': this.req.sharedClientBuOrCorpId });
        if (this.req.clientOrBU) {
            if (this.req.clientOrBU.companyType == 'Corporation') {
                this.sharedCorporateId = this.req.clientOrBU.id;
            }
            else {
                this.sharedCorporateId = null;
            }
        }
    }
    _setFileInUploadDropZone(fileName, fileSize) {
        let mockFile = {
            name: fileName,
            size: fileSize
        };
        this.reqUploadDropzone.options.addedfile.call(this.reqUploadDropzone, mockFile);
        // delete the DOM for 'remove button' option from the file in drop zone since job is now in 'open' status
        // find the remove button in the drop zone and delete it.
        $('.dz-remove').remove();
        // find the progress bar in the drop zone and delete it.
        $('.dz-progress').remove();
        // add the success tick mark onto the file
        $('.dz-file-preview.dz-preview').addClass('dz-success');
    }
    setProfileCriteriaInfoSkills(profileCriteriaInfo) {
        const categorizeSkills = (skills, skillType) => {
            if (skills && skills.length > 0) {
                return skills
                    .filter(skill => skill.displayName && skill.displayName.trim() !== '')
                    .map(skill => (Object.assign({}, skill, { skillType })));
            }
            return [];
        };
        profileCriteriaInfo.technicalSkills = categorizeSkills(profileCriteriaInfo.technicalSkills, 'TECHNICALSKILLS');
        profileCriteriaInfo.operationalSkills = categorizeSkills(profileCriteriaInfo.operationalSkills, 'OPERATIONALSKILLS');
        profileCriteriaInfo.otherSkills = categorizeSkills(profileCriteriaInfo.otherSkills, 'OTHERS');
        profileCriteriaInfo.softSkills = categorizeSkills(profileCriteriaInfo.softSkills, 'SOFTSKILLS');
        ['certifications', 'experiences', 'educations'].forEach(key => {
            profileCriteriaInfo[key] = profileCriteriaInfo[key]
                ? profileCriteriaInfo[key]
                    .filter(item => item.displayName && item.displayName.trim() !== '')
                    .map(item => (Object.assign({}, item)))
                : [];
        });
    }
    // save step1 details
    saveStep1Details(isRerun, successCallback, errorCallback) {
        let clientOrBUIdStepOne = !this.job.clientorbu ? null : this.job.clientorbu.id;
        this.job.profileCriteriaInfo.title = this.job.title;
        this.setProfileCriteriaInfoSkills(this.job.profileCriteriaInfo);
        let step1DetailsTempObject = {
            jobId: this.job.id,
            title: this.job.title,
            isSharedClientRequisition: this.currentJobStatus !== 'DRAFT' ? this.job.isSharedClientRequisition : this.req.isSharedClientRequisition,
            sharedClientBuOrCorpId: this.currentJobStatus !== 'DRAFT' ? this.job.sharedClientBuOrCorpId : this.req.sharedClientBuOrCorpId,
            clientOrBUId: clientOrBUIdStepOne,
            requistionNumber: this.job.requisitionNumber,
            isFutureMatchesOnly: this.isFutureMatchesOnly,
            profileCriteriaInfo: this.job.profileCriteriaInfo,
            source: this.currentJobStatus !== 'DRAFT' ? 'EDITREQ' : 'CREATEREQ',
            tab: this.currentJobStatus !== 'DRAFT' ? 'EDIT_REQUISITION' : 'ADD_REQUISITION'
        };
        step1DetailsTempObject.profileCriteriaInfo.userEnteredDescription = true;
        let updateFlag = true;
        let companyId = (this.job && this.job.company && this.job.company.id) ? this.job.company.id : this.userDetails.company.companyId;
        this.utilityService.showLoadingModal("Saving...");
        step1DetailsTempObject.rerunScore = isRerun;
        step1DetailsTempObject.recalculateLater = !isRerun;
        if (this.currentJobStatus !== 'DRAFT') {
            step1DetailsTempObject.includeCandidatesWithNoAdditionalDetails = this.job.includeCandidatesWithNoAdditionalDetails;
            step1DetailsTempObject.includeCandidatesMatchingMandatoryCriteria = this.job.includeCandidatesMatchingMandatoryCriteria;
            step1DetailsTempObject.asyncActionType = 'async';
            step1DetailsTempObject.criteriaUpdated = this.isSkillsChanged;
            step1DetailsTempObject.flagsUpdated = this.checkIfFlagsChanged(step1DetailsTempObject, this.step1DetailsTempObject);
            this.jobService.createUpdateJobDetails(updateFlag, step1DetailsTempObject, companyId, clientOrBUIdStepOne, this.userDetails.id, (data) => {
                this.job.profileCriteriaInfo = (data && data.t) ? Object.assign({}, data.t.profileCriteriaInfo) : this.job.profileCriteriaInfo;
                this.job.title = (data && data.t) ? data.t.title : this.job.title;
                this.updateUserCache();
                this.utilityService.hideLoadingModal();
                if (data && !data.t && data.message) {
                    let title = (!step1DetailsTempObject.rerunScore && step1DetailsTempObject.recalculateLater) ? "Job updated successfully." : "Job matching in Progress";
                    this.alertsAndNotificationsService.showAlertWithCallBack(title, data.message, "success", () => {
                        if (step1DetailsTempObject.rerunScore && !step1DetailsTempObject.recalculateLater) {
                            this.$state.go('missioncontrol.requisitions');
                        }
                    });
                }
                this._createStepTempObject(1);
                if (successCallback) {
                    successCallback();
                }
            }, (error) => {
                if (errorCallback) {
                    errorCallback(error);
                }
                this.utilityService.hideLoadingModal();
            });
        }
        else {
            updateFlag = false;
            clientOrBUIdStepOne = this.req.clientOrBU ? this.req.clientOrBU.id : null;
            this.jobService.createUpdateJobDetails(updateFlag, step1DetailsTempObject, companyId, clientOrBUIdStepOne, this.userDetails.id, (data) => {
                this.job.profileCriteriaInfo = (data && data.t) ? Object.assign({}, data.t.profileCriteriaInfo) : this.job.profileCriteriaInfo;
                this.job.title = (data && data.t) ? data.t.title : this.job.title;
                this._createStepTempObject(1);
                if (successCallback) {
                    successCallback();
                }
                this.updateUserCache();
                this.utilityService.hideLoadingModal();
            }, (error) => {
                if (errorCallback) {
                    errorCallback(error);
                }
                this.utilityService.hideLoadingModal();
            });
        }
    }
    /**
     * save step2 details - requisition number, recruiters,job type, sponsorships
    * */
    saveStep2Details(buttonType, successCallback, errorCallback) {
        if (_.isNull(this.job.sponsorships)) {
            this.job.sponsorships = [];
        }
        if (_.isNull(this.job.workLocationIds)) {
            this.job.workLocationIds = [];
        }
        let clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        let step2DetailsObject = {
            jobId: this.job.id,
            title: this.job.title,
            isSharedClientRequisition: this.job.isSharedClientRequisition,
            sharedClientBuOrCorpId: this.job.sharedClientBuOrCorpId,
            clientOrBUId: clientOrBUId,
            requistionNumber: this.job.requisitionNumber,
            openings: this.job.openings,
            jobType: this.job.jobType,
            contractDuration: this.job.contractDuration,
            requisitionNote: this.job.requisitionNote,
            jobSalary: angular.copy(this.job.jobSalary),
            sponsorships: this.job.sponsorships,
            sponsorshipProvided: this.job.sponsorshipProvided,
            workLocationIds: this.job.workLocationIds,
            recruiters: this.job.recruiters,
            hiringManagers: angular.copy(this.job.hiringManagers),
            vendorIds: this.job.vendorIds,
            pointOfContactUserId: this.job.pointOfContactUserId,
            tab: "ASSIGN_RECRUITERS",
            endClientId: this.job.endClientId
        };
        let updateFlag = (this.step2DetailsSavedFlag && (this.currentJobStatus == 'OPEN'));
        step2DetailsObject.actionType = this.editModeFlag ? "UPDATE" : "ADD";
        step2DetailsObject.source = this.editModeFlag ? "EDITREQ" : "CREATEREQ";
        if (this.isAsyncProcess && this.currentJobStatus !== 'DRAFT') {
            this.isUiCanExit = true;
            step2DetailsObject.asyncActionType = buttonType;
            this.jobService.createUpdateJobDetails(updateFlag, step2DetailsObject, this.job.company.id, clientOrBUId, this.userDetails.id, (data) => {
                // Refresh requisition 
                this.updateRequisitionIcons(data.t);
            }, () => { });
            this.savingFlag = false;
            this.utilityService.hideLoadingModal();
            let message = "Job match process has started in the background and will inform all users on the Requisition when its completed.";
            if (this.isRecalcucateScoreNoClicked) {
                this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => {
                    this.alertsAndNotificationsService.showAlertWithCallBack("Job matching in Progress", message, "success", () => {
                        this.$state.go('missioncontrol.requisitions');
                    });
                });
            }
            else {
                this.alertsAndNotificationsService.showAlertWithCallBack("Job matching in Progress", message, "success", () => {
                    this.$state.go('missioncontrol.requisitions');
                });
            }
            this.updateUserCache();
        }
        else {
            this.jobService.createUpdateJobDetails(updateFlag, step2DetailsObject, this.job.company.id, clientOrBUId, this.userDetails.id, (data) => {
                this.updateRequisitionIcons(data.t);
                this.editTitleFlag = false;
                this.editBUFlag = false;
                if (!clientOrBUId) {
                    this.req.clientOrBU = null;
                }
                else {
                    angular.forEach(this.clientorbulist, (val, key) => {
                        if (val.id == this.job.clientorbu.id) {
                            this.req.clientOrBU = val;
                        }
                    });
                }
                this.step2DetailsSavedFlag = true;
                if (successCallback) {
                    successCallback();
                }
                this.updateUserCache();
            }, (error) => {
                if (errorCallback) {
                    errorCallback(error);
                }
            });
        }
    }
    /**
     * update the job's location
     */
    updateLocation() {
        let vm = this;
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            template: UploadReqUpdateLocationModalTemplate.default,
            controller: ['$uibModalInstance', 'jobId', 'location', function ($uibModalInstance, jobId, location) {
                    this.jobId = jobId;
                    this.location = location;
                    this.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                    this.clearLocation = () => {
                        vm.job.locationLabel = "";
                        vm.job.location = null;
                        vm.isJobLocationChanged = true;
                        this.closeModal();
                    };
                    this.saveCallback = (locationObject) => {
                        this.closeModal();
                        vm.isJobLocationChanged = true;
                        vm.updateLocationCallback(locationObject);
                    };
                }],
            controllerAs: 'updateLocationModal',
            size: 'lg',
            resolve: {
                jobId: () => {
                    return vm.job.id;
                },
                location: () => {
                    let locationObject = angular.copy(vm.job.location);
                    // locationObject.city = _.isNull(locationObject.city) ? null: locationObject.city.name;
                    return locationObject;
                }
            }
        });
    }
    updateLocationCallback(locationObject) {
        // update the location label
        this.job.locationLabel = locationObject.city + ', ' + locationObject.state + ', ' + locationObject.zipCode;
        //let cityName = locationObject.city;
        //locationObject.city = {};
        //locationObject.city.name = cityName;
        this.job.location = locationObject;
    }
    /**
     *
     * save the workflow steps
     *
     */
    saveWorkflowSteps(isRerun, successCallback, errorCallback) {
        let workflowStepsObject = {
            jobId: this.job.id,
            score: this.job.score,
            autoMatch: this.job.autoMatch,
            recruiterScreening: this.job.recruiterScreening,
            techAssessmentId: this.job.techAssessmentId,
            techAssessmentScore: this.job.techAssessmentScore,
            techAssessment: this.job.techAssessment,
            valueAssessmentId: this.job.valueAssessmentId,
            valueAssessment: this.job.valueAssessment,
            eduVerification: this.job.eduVerification,
            expVeification: this.job.expVeification,
            phoneScreen: this.job.phoneScreen,
            interview: this.job.interview,
            imageProctoring: this.job.imageProctoring,
            addProctoringImagesToReport: this.job.addProctoringImagesToReport,
            workflowStepsOrder: angular.copy(this.job.workflowStepsOrder),
            includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
            includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
            // jobBoardDetails: this.job.jobBoardDetails,
            // resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
            tab: "WORKFLOW_STEPS"
        };
        let updateFlag = (this.workflowStepsSavedFlag && (this.currentJobStatus == 'OPEN'));
        let clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        workflowStepsObject.actionType = this.editModeFlag ? "UPDATE" : "ADD";
        workflowStepsObject.source = this.editModeFlag ? "EDITREQ" : "CREATEREQ";
        let flagsUpdated = this.checkIfFlagsChanged(workflowStepsObject, this.workflowStepsTempObject);
        if (flagsUpdated) {
            workflowStepsObject.asyncActionType = this.currentJobStatus != 'DRAFT' ? 'async' : null;
            workflowStepsObject.criteriaUpdated = false;
            workflowStepsObject.flagsUpdated = flagsUpdated;
            workflowStepsObject.rerunScore = isRerun;
            workflowStepsObject.recalculateLater = !isRerun;
        }
        this.jobService.createUpdateJobDetails(updateFlag, workflowStepsObject, this.job.company.id, clientOrBUId, this.userDetails.id, (data) => {
            // Refresh requisition icons
            this.updateRequisitionIcons(data.t);
            this.workflowStepsSavedFlag = true;
            this.isLicensePreferenceSet = true;
            if (flagsUpdated && this.currentJobStatus != 'DRAFT') {
                let title = (!workflowStepsObject.rerunScore && workflowStepsObject.recalculateLater) ? "Job updated successfully." : "Job matching in Progress";
                this.alertsAndNotificationsService.showAlertWithCallBack(title, data.message, "success", () => {
                    if (workflowStepsObject.rerunScore && !workflowStepsObject.recalculateLater) {
                        this.$state.go('missioncontrol.requisitions');
                    }
                });
            }
            if (successCallback) {
                successCallback();
            }
            this.updateUserCache();
        }, (error) => {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }
    _updateDataAfterWorkflowStepsSaved(isRerun, currentStep, successCallback, errorCallback) {
        this.disableAllButtonsFlag = true;
        this.savingFlag = true;
        this.utilityService.showLoadingModal("Saving...");
        this.saveWorkflowSteps(isRerun, () => {
            this.utilityService.hideLoadingModal();
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            // show the message that the job is saved state
            if (this.$rootScope.isOnline) {
                let successMessage = 'The Requisition details have been saved in Draft Status.';
                if (this.currentJobStatus == 'OPEN') {
                    successMessage = 'The Requisition details have been saved.';
                }
                this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
            }
            this._createStepTempObject(currentStep);
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.utilityService.hideLoadingModal();
            this.disableAllButtonsFlag = false;
            this.savingFlag = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    _updateDataAfterWorkflowStepsSavedNextClicked(isRerun, data, successCallback, errorCallback) {
        this.step3RequestWasInProgressFlag = true;
        this.utilityService.showLoadingModal("Saving...");
        this.saveWorkflowSteps(isRerun, () => {
            // if (this.currentJobStatus === "DRAFT") {
            //             $("#uploadReqWizard").wizard('next');
            // }else{
            this.getJobBoardParameters(() => {
                this.getRadiusAndRecencyOptions(() => {
                    this._createStepTempObject(data.step + 1);
                    this.utilityService.hideLoadingModal();
                    if (successCallback) {
                        successCallback();
                    }
                }, (error) => {
                    this._enableStepActionsOnWizard(data.step);
                    this.utilityService.hideLoadingModal();
                    // show error messages
                    if (this.$rootScope.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    if (errorCallback) {
                        errorCallback();
                    }
                    // no move to next step
                });
            }, (error) => {
                this._enableStepActionsOnWizard(data.step);
                this.utilityService.hideLoadingModal();
                // show error messages
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                if (errorCallback) {
                    errorCallback();
                }
                // no move to next step
            });
            //  }
        }, (error) => {
            this._enableStepActionsOnWizard(data.step);
            this.utilityService.hideLoadingModal();
            // show error messages
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
            // no move to next step
        });
    }
    /**
     *
     * save the Job boards settings
     *
     */
    saveJobBoardsSettings(buttonType, successCallback, errorCallback) {
        this.utilityService.showLoadingModal("Saving...");
        let jobBoardsObject = {
            jobId: this.job.id,
            score: this.job.score,
            autoMatch: this.job.autoMatch,
            jobBoardDetails: this.job.jobBoardDetails,
            resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
            isResumePullEnabled: this.job.isResumePullEnabled,
            radius: this.job.radius,
            recency: this.job.recency,
            buttonType: buttonType,
            tab: "JOB_BOARDS"
        };
        let updateFlag = (this.jobBoardsSettingsSavedFlag && (this.currentJobStatus == 'OPEN'));
        let clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        jobBoardsObject.actionType = this.editModeFlag ? "UPDATE" : "ADD";
        jobBoardsObject.source = this.editModeFlag ? "EDITREQ" : "CREATEREQ";
        this.jobService.createUpdateJobDetails(updateFlag, jobBoardsObject, this.job.company.id, clientOrBUId, this.userDetails.id, (data) => {
            this.jobBoardsSettingsSavedFlag = true;
            this.isJobBoardDetailsSet = true;
            if (successCallback) {
                successCallback();
            }
            this.utilityService.hideLoadingModal();
            this.updateUserCache();
        }, (error) => {
            if (errorCallback) {
                errorCallback(error);
            }
            this.utilityService.hideLoadingModal();
        });
    }
    /**
     * save the adjusted 4dot5 intelligence score
     */
    saveAdjusted4dot5Score(score, successCallback, errorCallback) {
        this.utilityService.showLoadingModal("Saving...");
        let saveObject = {
            jobId: this.job.id,
            score: score,
            candidatesToMatch: this.currentScoreCandidateCounts.candidatesToMatch
        };
        this.jobService.update4dot5Score(saveObject, (data) => {
            this.job.score = score;
            this.getCandidateCount(this.job.score, 'currentScore', () => {
                this._createCountSliders();
                this.utilityService.hideLoadingModal();
                if (successCallback) {
                    successCallback(data);
                }
            });
        }, (error) => {
            if (errorCallback) {
                errorCallback(error);
            }
            this.utilityService.hideLoadingModal();
        });
    }
    /**
     *  save the job details
     */
    saveJob(successCallback, errorCallback) {
        let jobSaveObject = {};
        jobSaveObject.id = this.job.id;
        jobSaveObject.requisitionNumber = this.job.requisitionNumber;
        jobSaveObject.recruiters = this.job.recruiters;
        jobSaveObject.hiringManagers = angular.copy(this.job.hiringManagers);
        jobSaveObject.jobType = 'FULLTIME';
        jobSaveObject.jobSalary = angular.copy(this.job.jobSalary);
        this.jobService.saveJob(jobSaveObject, (data) => {
            this.job = data;
            successCallback();
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            errorCallback();
        });
    }
    /**
     * set job status to open
     */
    setJobStatusToOpen(successCallback, errorCallback) {
        this.jobService.setJobStatusToOpen(this.job.id, (data) => {
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    /**
     * run job for scoring
     */
    runJobForScoring(successCallback, errorCallback) {
        this.jobService.runJobForScoring(this.job.company.id, this.job.id, this.job.transactionId, (data) => {
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    /**
     * get Candidates Count
     */
    getCandidateCount(score, scoreType, successCallback, errorCallback) {
        if (scoreType == 'adjustedScore') {
            this.loadingAdjustedCandidatesCountFlag = true;
        }
        let isNew = this.isInitialStateDraft;
        this.jobService.getCandidateCount(this.job.id, score, this.job.transactionId, isNew, (data) => {
            if (scoreType == 'currentScore') {
                // set both the current score and adjusted score candidate counts
                this.currentScoreCandidateCounts = data;
                this.adjustedScoreCandidateCounts = data;
            }
            else if (scoreType == 'adjustedScore') {
                // set only the adjusted score candidate counts
                this.adjustedScoreCandidateCounts = data;
                this.loadingAdjustedCandidatesCountFlag = false;
            }
            if (successCallback) {
                successCallback(data);
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }
    /**
     * get candidates by requisition transaction
     */
    getCandidatesByRequisitionTransaction(countType, scoreType) {
        this.candidatesBasedOnRequisitionTransaction = [];
        let score = this.job.score;
        if (scoreType == 'adjustedScore') {
            // set the adjusted score
            score = $('.slider-adjust-4dot5-score').val();
        }
        let vm = this;
        this.candidateCardNotesModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            windowTopClass: 'four-dot-five-modal-large',
            template: UploadReqTransactionsCandidateModalTemplate.default,
            controller: ['$uibModalInstance', 'jobId', 'jobScore', 'score', 'transactionId', 'countType', 'clientOrBuLabel', 'jobService', 'candidateService', 'alertsAndNotificationsService', function ($uibModalInstance, jobId, jobScore, score, transactionId, countType, clientOrBuLabel, jobService, candidateService, alertsAndNotificationsService) {
                    this.candidates = [];
                    this.jobScore = jobScore;
                    this.clientOrBuLabel = clientOrBuLabel;
                    this.loadingFlag = true;
                    this.jobService = jobService;
                    this.candidateService = candidateService;
                    this.alertsAndNotificationsService = alertsAndNotificationsService;
                    // functions
                    this.init = init;
                    this.getCandidateJobMatches = getCandidateJobMatches;
                    this.closeModal = closeModal;
                    this.init = () => {
                        this.jobService.getCandidatesByRequisitionTransaction(jobId, vm.companyId, score, transactionId, countType, (data) => {
                            this.candidates = data;
                            angular.forEach(this.candidates, (val, key) => {
                                val.name = val.firstName;
                                if (!_.isNull(val.lastName)) {
                                    val.name += " " + val.lastName;
                                }
                                val.candidateJobMatches = [];
                                if (_.isUndefined(val.currentJobScore)) {
                                    val.currentJobScore = 0;
                                }
                                if (val.currentJobScore == 0) {
                                    val.currentJobScore = 'N/A';
                                }
                                else {
                                    val.intelligenceScorePassFlag = false;
                                    if (val.currentJobScore >= this.jobScore) {
                                        val.intelligenceScorePassFlag = true;
                                    }
                                    // round the match score to the lower integer value.
                                    val.currentJobScore = Math.floor(parseFloat(val.currentJobScore));
                                }
                                let cardPosition = key % 4;
                                switch (cardPosition) {
                                    case 0:
                                        val.jobMatchesPopoverPosition = 'bottom-left';
                                        break;
                                    case 1:
                                        val.jobMatchesPopoverPosition = 'bottom';
                                        break;
                                    case 2:
                                        val.jobMatchesPopoverPosition = 'bottom';
                                        break;
                                    case 3:
                                        val.jobMatchesPopoverPosition = 'bottom-right';
                                        break;
                                }
                                this.getCandidateJobMatches(val.id, (data) => {
                                    val.candidateJobMatches = data;
                                });
                            });
                            this.loadingFlag = false;
                        }, (error) => {
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            this.loadingFlag = false;
                        });
                    };
                    this.closeModal = () => {
                        $uibModalInstance.dismiss('cancel');
                    };
                    this.getCandidateJobMatches = (candidateId, successCallback) => {
                        let candidateJobMatches = [];
                        let jobMatchesObject = new JobMatchQueryFilter();
                        jobMatchesObject.candidateId = candidateId;
                        jobMatchesObject.userId = this.userId;
                        jobMatchesObject.companyId = this.companyId;
                        jobMatchesObject.top5Flag = true;
                        jobMatchesObject.candidateType = 'OWN_CANDIDATES';
                        jobMatchesObject.searchText = '';
                        jobMatchesObject.vendorIds = [];
                        this.candidateService.getCandidateJobMatches(jobMatchesObject, '', '', (data) => {
                            angular.forEach(data, (val, key) => {
                                val.jobMatchDate = new Date(val.jobMatchDate);
                                if (_.isNull(val.fourDotFiveIntelligentScore)) {
                                    val.fourDotFiveIntelligentScore = 'N/A';
                                }
                                candidateJobMatches.push(val);
                            });
                            if (successCallback) {
                                successCallback(candidateJobMatches);
                            }
                        }, (error) => {
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    };
                    this.init();
                }],
            controllerAs: 'candidatesModal',
            size: 'lg',
            resolve: {
                jobId: () => {
                    return vm.job.id;
                },
                score: () => {
                    return score;
                },
                jobScore: () => {
                    return vm.job.score;
                },
                transactionId: () => {
                    return vm.job.transactionId;
                },
                countType: () => {
                    return countType;
                },
                clientOrBuLabel: () => {
                    return vm.clientOrBuLabel;
                }
            }
        });
    }
    /**
     * update the action buttons
     */
    updateActionButtons() {
        let wizardCurrentStep = $('#uploadReqWizard').wizard('selectedItem').step;
        switch (wizardCurrentStep) {
            case 1:
                this.isStepOneActive = true;
                this.isClientOrBuRequired = false;
                if (this.clientOrBUIsRequiredFlag) { //Client
                    // if - client is chosen and file exists in drop zone and there is no job id
                    // Enable the upload button
                    if (this.req.clientOrBU && angular.isDefined(this.req.clientOrBU) && angular.isDefined(this.req.clientOrBU.id) && this.fileExistsFlag && ((!_.isNull(this.job)) && (_.isNull(this.job.id))) && (this.req.clientOrBU.companyType !== 'Corporation' || (this.req.clientOrBU.companyType == 'Corporation' && !_.isNull(this.req.sharedClientBuOrCorpId)))) {
                        this.disableUploadButtonFlag = false;
                    }
                    else if (this.fileExistsFlag && (!this.req.clientOrBU || !this.req.clientOrBU.id)) {
                        this.isClientOrBuRequired = true;
                        this.disableUploadButtonFlag = true;
                    }
                    else {
                        if (this.req.clientOrBU && this.req.clientOrBU.id) {
                            this.disableNextButtonFlag = false;
                        }
                        this.disableUploadButtonFlag = true;
                    }
                }
                else { //BU
                    if ((this.req.clientOrBU || this.isAssociatedBuSelected()) && (this.fileExistsFlag && ((!_.isNull(this.job)) && (_.isNull(this.job.id))))) {
                        this.disableUploadButtonFlag = false;
                    }
                    else if (!this.req.clientOrBU && this.clientorbulist.filter(clientOrBu => clientOrBu.id === "").length == 0) {
                        this.isClientOrBuRequired = true;
                        this.disableUploadButtonFlag = true;
                    }
                    else {
                        this.disableUploadButtonFlag = true;
                    }
                }
                // // save button is always disabled in this step
                // this.disableSaveButtonFlag = true;
                // // if job is defined, that means an upload was done for current client. Hence the next button should be enabled.
                if (angular.isDefined(this.job.id) && this.job.id != null) {
                    // enable the next button
                    this.disableNextButtonFlag = false;
                    // For Edit requisitions detials screen
                    this.disableSaveButtonFlag = false;
                }
                else {
                    // disable the next button
                    if ((!this.isUploadRequisition && (this.isCorporate || (this.req.clientOrBU && this.req.clientOrBU.id)))) {
                        this.disableNextButtonFlag = false;
                    }
                    else {
                        this.disableNextButtonFlag = true;
                    }
                }
                break;
            case 2:
                this.isStepOneActive = false;
                this.disableSaveButtonFlag = false;
                break;
            case 3:
                this.disableSaveButtonFlag = false;
                break;
            case 6:
                this.disableSaveButtonFlag = false;
                break;
            default:
                break;
        }
        this.$timeout(() => {
            this.$scope.$apply();
        }, 200);
    }
    isAssociatedBuSelected() {
        return !this.req.clientOrBU && this.clientorbulist.filter(clientOrBu => clientOrBu.id === "").length > 0;
    }
    /**
     * Process the file queue in the drop zone and upload the requisition
     */
    uploadRequisition() {
        this.reqUploadDropzone.processQueue();
    }
    launchAdvancedJobBoardSearch() {
        this.candidateCardNotesModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            templateUrl: 'app/partials/missioncontrol/uploadreq/upload-req-advanced-job-search-modal.html',
            controller: ['$uibModalInstance', 'requisitionService', 'alertsAndNotificationsService', function ($uibModalInstance, requisitionService, alertsAndNotificationsService) {
                    let vm = this;
                    this.loadingFlag = true;
                    this.requisitionService = requisitionService;
                    this.alertsAndNotificationsService = alertsAndNotificationsService;
                    this.closeModal = () => {
                        $uibModalInstance.dismiss('cancel');
                    };
                    this.requisitionService.getJobBoardsAdvancedSearchInterface({}, (data) => {
                        this.loadingFlag = false;
                        this.jobBoardResponseHTML = this.$sce.trustAsHtml(data.html);
                        this.jobBoardResponseCSS = data.libs.css;
                        this.jobBoardResponseParamsJS = data.libs.jb_params_jq;
                        this.jobBoardResponseJS = data.js;
                    }, (error) => {
                        this.loadingFlag = false;
                        if (this.$rootScope.isOnline) {
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                    });
                }],
            controllerAs: 'jobBoardSearchModal',
            size: 'lg'
        });
    }
    useJobBoardChange() {
        if (!this.job.isResumePullEnabled) {
            // this.job.jobBoardDetails = angular.copy(this.jobBoardDetailsCopy);
        }
    }
    getResumesFromJobBoards(saveCallback, errorCallback) {
        this.jobService.getResumesFromJobBoards(this.job.id, this.job.jobBoardDetails, this.job.resumesToPullPerJobBoardCount, this.job.radius, this.job.recency, (data) => {
            if (saveCallback) {
                saveCallback();
            }
        }, (error) => {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }
    onActivateRequisitionSwitchChange() {
        this.disableNextButtonFlag = this.isActivateRequisitionEnabled ? false : true;
    }
    onJobBoardSelectionChange() {
        this.isJobBoardSelected = false;
        angular.forEach(this.job.jobBoardDetails, (val, key) => {
            if (val.enabled == true) {
                this.isJobBoardSelected = true;
            }
        });
    }
    onSalaryTypeChange(salaryType) {
        if (this.job.jobSalary.salaryDuration == undefined) {
            this.job.jobSalary = new JobSalary();
            this.job.jobSalary.currency = "USD";
            this.job.jobSalary.salaryType = salaryType;
            this._setSalaryRangeOptions();
        }
        if (!this.job.jobSalary.currency) {
            this.job.jobSalary.currency = "USD";
        }
    }
    onStepSelectionChange(stepStatus, stepDetails, verificationStepName) {
        let showWarningMessage = false;
        if (stepDetails.isCandidatesPresentOnStep && !stepStatus && verificationStepName == undefined) {
            switch (stepDetails.name) {
                case "Recruiter Screening":
                    this.job.recruiterScreening = true;
                    showWarningMessage = true;
                    break;
                case "Tech Assessment":
                    this.job.techAssessment = true;
                    showWarningMessage = true;
                    break;
                case "Value Assessment":
                    this.job.valueAssessment = true;
                    showWarningMessage = true;
                    break;
                case "Phone Screen":
                    this.job.phoneScreen = true;
                    showWarningMessage = true;
                    break;
                case "Interview":
                    this.job.interview = true;
                    showWarningMessage = true;
                    break;
            }
            if (showWarningMessage) {
                this._showCandidatesAvailableOnStepWarning(stepDetails.candidatesPresentMessage, stepDetails.name);
            }
        }
        if (verificationStepName == "Education Verification" && stepDetails.isCandidatesPresentOnStepEducationVerification && !stepStatus) {
            this.job.eduVerification = true;
            this._showCandidatesAvailableOnStepWarning(stepDetails.candidatesPresentMessageEducationVerification, stepDetails.name);
        }
        if (verificationStepName == "Experience Verification" && stepDetails.isCandidatesPresentOnStepExperienceVerification && !stepStatus) {
            this.uploadReq.job.expVeification = true;
            this._showCandidatesAvailableOnStepWarning(stepDetails.candidatesPresentMessageExperienceVerification, stepDetails.name);
        }
        this.validateStepThree();
        this._massageWorkflowStepsOrder();
    }
    _showCandidatesAvailableOnStepWarning(message, stepName) {
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: UploadReqWorkflowStepWarningModalTemplate.default,
            backdrop: 'static',
            controller: ['$uibModalInstance', 'message', 'stepName', function ($uibModalInstance, message, stepName) {
                    let vm = this;
                    this.message = message;
                    this.stepName = stepName;
                    this.closeModal = () => {
                        $uibModalInstance.dismiss('cancel');
                    };
                }],
            controllerAs: 'warningModal',
            size: 'sm',
            windowTopClass: 'four-dot-five-modal-small',
            resolve: {
                message: () => {
                    return message;
                },
                stepName: () => {
                    return stepName;
                }
            }
        });
    }
    _showcandidatesPresentOnJobWarningMessage(successCallback) {
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: 'Cannot change the Job Type as candidate(s) exist in the Requisition!',
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            },
            callback: () => {
                if (successCallback) {
                    successCallback();
                }
            }
        });
    }
    showJobProfile() {
        let vm = this;
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: UploadReqJobProfileModalTemplate.default,
            backdrop: 'static',
            controller: ['$uibModalInstance', 'jobId', function ($uibModalInstance, jobId) {
                    let vm = this;
                    this.jobId = jobId;
                    this.modalHeading = 'Job Profile';
                    this.closeModal = () => {
                        $uibModalInstance.dismiss('cancel');
                    };
                }],
            controllerAs: 'jobProfileModal',
            size: 'lg',
            windowTopClass: 'four-dot-five-modal-large',
            resolve: {
                jobId: () => {
                    return vm.job.id;
                }
            }
        });
    }
    _setEndClient(tempObj) {
        this.endClient = tempObj.endClient ? [tempObj.endClient] : null;
        tempObj.endClientId = tempObj.endClient ? tempObj.endClient.id : null;
    }
    _addEditEndClient(type, endClientName, successCallback) {
        if (type === 'Add') {
            let tempEndClient = {};
            this.endClient = null;
            tempEndClient = {
                companyId: this.companyId,
                name: endClientName
            };
            this.jobService.addEndClient(this.userId, tempEndClient, (data) => {
                if (data) {
                    let message = `${type}ed End Client Successfully.`;
                    this.alertsAndNotificationsService.showBannerMessage(message, 'success');
                    this.endClient = [{
                            companyId: data.companyId,
                            name: data.name,
                            id: data.id
                        }];
                    this.job.endClientId = data.id;
                    if (successCallback) {
                        successCallback();
                    }
                }
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else if (type === 'Edit') {
            let endClientCopy = angular.copy(this.endClient);
            let tempEndClient = {};
            tempEndClient.id = endClientCopy[0].id;
            tempEndClient.name = endClientName;
            tempEndClient.companyId = endClientCopy[0].companyId ? endClientCopy[0].companyId : this.companyId;
            this.endClient = null;
            this.jobService.editEndClient(this.userId, this.job.id, tempEndClient, (data) => {
                if (data) {
                    this.endClient = null;
                    this.endClient = [{
                            companyId: data.companyId,
                            name: data.name,
                            id: data.id,
                            associatedReqDetails: data.associatedReqDetails
                        }];
                    this.job.endClientId = data.id;
                    if (successCallback) {
                        successCallback();
                    }
                }
            }, (error) => {
                this.endClient = endClientCopy;
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else if (type === 'Delete') {
            this.jobService.deleteEndClient(this.endClient[0].id, (data) => {
                if (data) {
                    let message = `${type}d End Client Successfully.`;
                    this.alertsAndNotificationsService.showBannerMessage(message, 'success');
                    this.endClient = null;
                    this.job.endClientId = null;
                    if (successCallback) {
                        successCallback();
                    }
                }
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }
    addEditEndClient(type) {
        this.endClientSearchText = type === 'Add' ? "" : this.endClientSearchText;
        this.isManageEndClient = (type === 'Manage' && this.endClient) ? true : false;
        if (type === 'Edit' || type === 'Delete') {
            this.isManageEndClient = false;
            this.addEditClientName = angular.copy(this.endClient[0].name);
            if (type === 'Delete') {
                this.associatedEdClientReqDetails = angular.copy(this.endClient[0].associatedReqDetails);
            }
            else {
                this.associatedEdClientReqDetails = [];
            }
        }
        else {
            this.addEditClientName = "";
        }
        if (type === 'Add' || type === 'Edit' || type === 'Delete') {
            let vm = this;
            this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                template: UploadReqAddEditEndClientTemplate.default,
                controller: ['$uibModalInstance', 'type', 'addEditClientName', 'isEndClientNameValid', 'endClientDetails', function ($uibModalInstance, type, addEditClientName, isEndClientNameValid, endClientDetails) {
                        this.type = type;
                        this.addEditClientName = addEditClientName;
                        this.isEndClientNameValid = isEndClientNameValid;
                        this.endClientDetails = endClientDetails;
                        this.closeModal = () => {
                            $uibModalInstance.close('cancel');
                        };
                        this.saveCallback = (type, addEditClientName) => {
                            vm.addEditClientName = addEditClientName;
                            if (addEditClientName.length > 0) {
                                vm.isEndClientNameValid = false;
                                vm._addEditEndClient(type, addEditClientName, () => {
                                    this.closeModal();
                                });
                            }
                            else {
                                vm.isEndClientNameValid = true;
                            }
                        };
                    }],
                controllerAs: 'addEditModal',
                windowTopClass: 'four-dot-five-modal-extra-small',
                resolve: {
                    type: () => {
                        return type;
                    },
                    addEditClientName: () => {
                        return vm.addEditClientName;
                    },
                    isEndClientNameValid: () => {
                        return vm.isEndClientNameValid;
                    },
                    endClientDetails: () => {
                        return vm.associatedEdClientReqDetails;
                    }
                }
            });
        }
    }
    getEndClientTypeAhead(searchTerm) {
        return this.jobService.getEndClients(this.companyId, this.job.id, searchTerm).then(data => {
            return data;
        });
    }
    endClientTypeAheadTagAdded(tag) {
        this.addEditClientName = tag.name;
        if (tag.id) {
            this.job.endClientId = tag.id;
        }
    }
    endClientTypeAheadTagRemoved(tag) {
        this.isManageEndClient = false;
        this.endClient = null;
        this.job.endClientId = null;
    }
    sendOutreachEmailToCandidates(candidateIds) {
        let candidateIdsAndCandidateTypes = [];
        if (candidateIds && candidateIds.length > 0) {
            candidateIds.forEach(candidateId => {
                candidateIdsAndCandidateTypes.push({
                    id: candidateId,
                    candidateType: "OWN_CANDIDATES"
                });
            });
        }
        if (this.isOutreachEnabled && this.sendOutreachEmail && candidateIds && candidateIdsAndCandidateTypes.length > 0) {
            let outreachObject = {
                candidates: candidateIdsAndCandidateTypes,
                userId: this.userId,
                companyId: this.companyId,
                clientOrBuId: this.currentJobStatus != 'Draft' ? this.job.clientorbu.id : this.req.clientOrBU.id
            };
            this.candidateService.sendOutreachEmail(outreachObject, (data) => {
                this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }
    updateUserCache() {
        // Update User Cache
        this.userService.userCache(null, () => { }, () => { });
    }
    setWorkflowStepsOrderInIcons(workflowSteps) {
        const steps = [
            { key: 'recruiterScreening', label: 'Recruiter Screening' },
            { key: 'techAssessment', label: 'Tech Assessment' },
            { key: 'valueAssessment', label: 'Value Assessment' },
            { key: 'phoneScreen', label: 'Phone Screen' },
            { key: 'interview', label: 'Interview' }
        ];
        this.requisitionInfo.workflowSteps = steps
            .filter(step => workflowSteps[step.key])
            .map(step => step.label);
    }
    updateRequisitionIcons(data) {
        if (data && this.currentJobStatus != 'DRAFT') {
            if (data.vendorIds && data.vendorIds.length > 0) {
                this.requisitionInfo.vendorsDetails = [];
                this.vendorsList.forEach(vendor => {
                    if (data.vendorIds.includes(vendor.vendorId)) {
                        let vendorTemp = {
                            id: vendor.vendorId,
                            name: vendor.vendorName
                        };
                        this.requisitionInfo.vendorsDetails.push(vendorTemp);
                    }
                });
            }
            else {
                this.requisitionInfo.vendorsDetails = [];
            }
            if (data.jobSalary) {
                this.job.requisitionSalaryDisplayMessage = this.requisitionService._getSalaryDetailsDisplayMessage(data.jobSalary, this.allSalaryDurationOptions);
            }
            this.requisitionInfo = Object.assign({}, this.requisitionInfo, { fourDotFiveIntelligentThresholdScore: data.fourDotFiveIntelligenceScore, autoMatedMatchSelected: data.licensePreferences.autoMatch, techAssessmentId: data.techAssessmentId, valueAssessmentId: data.valueAssessmentId });
            this.setWorkflowStepsOrderInIcons(data.licensePreferences);
        }
    }
    createRequisitionWithouFile(successCallback, errorCallback) {
        let clientOrBUIdStepOne = this.req.clientOrBU ? this.req.clientOrBU.id : "";
        this.setProfileCriteriaInfoSkills(this.job.profileCriteriaInfo);
        let step1DetailsTempObject = Object.assign({}, this.job.profileCriteriaInfo);
        step1DetailsTempObject.title = this.job.title;
        if (this.job.location && this.job.location.city) {
            step1DetailsTempObject.location = Object.assign({}, this.job.location);
            step1DetailsTempObject.location.city = { name: this.job.location.city };
        }
        step1DetailsTempObject.sharedClientBuOrCorpId = this.req.sharedClientBuOrCorpId;
        step1DetailsTempObject.isSharedClientRequisition = this.req.isSharedClientRequisition;
        step1DetailsTempObject.userEnteredDescription = true;
        let companyId = this.userDetails.company.companyId;
        this.utilityService.showLoadingModal("Saving...");
        this.requisitionSkillsLoading = true;
        step1DetailsTempObject.source = 'CREATEREQ';
        this.jobService.createJobDescription(step1DetailsTempObject, companyId, clientOrBUIdStepOne, this.userDetails.id, (data) => {
            this.job = this._parseJobResponse(data);
            this._setSponsorshipSelectedDefault(false);
            this._createStepTempObject(1);
            this._createStepTempObject(2);
            this.getAllJobBoards(() => {
                this._setJobBoardDetails();
            });
            // this._massageWorkflowStepsOrder();
            this.updateActionButtons();
            // Edit requisition Details
            this.isEditRequisitionDetails = true;
            this.isUploadRequisition = false;
            this.isUploadAndEditRadioBtn = false;
            this.requisitionSkillsLoading = false;
            this.isClientOrBuDisabled = true;
            this.updateUserCache();
            this.utilityService.hideLoadingModal();
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.requisitionSkillsLoading = false;
            this.utilityService.hideLoadingModal();
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    reRunResumeScore(message, successCallback) {
        let requestObject = new RunCandidateScore(this.companyId, this.userId);
        requestObject.jobId = this.job.id;
        requestObject.rerunType = "REQUISITION";
        requestObject.source = "EDITREQ";
        this.resumeService.reRunResumeScore(requestObject, (data) => {
            this.alertsAndNotificationsService.showAlertWithCallBack("Candidate scoring in Progress", message ? message : data.message, "success", () => {
                this.isRecalcucateScoreNoClicked = false;
                if (successCallback) {
                    successCallback();
                }
            });
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    hasMatchingMandatoryCriteriaChanged() {
        return (this.workflowStepsTempObject.includeCandidatesMatchingMandatoryCriteria != this.job.includeCandidatesMatchingMandatoryCriteria);
    }
    hasMissingPreferenceDetailsChanged() {
        return (this.workflowStepsTempObject.includeCandidatesWithNoAdditionalDetails != this.job.includeCandidatesWithNoAdditionalDetails);
    }
    checkIfFlagsChanged(currentStep1TempObject, step1DetailsTempObject) {
        return (step1DetailsTempObject.includeCandidatesWithNoAdditionalDetails !== currentStep1TempObject.includeCandidatesWithNoAdditionalDetails) ||
            (step1DetailsTempObject.includeCandidatesMatchingMandatoryCriteria !== currentStep1TempObject.includeCandidatesMatchingMandatoryCriteria);
    }
    //Handle navigating away when data is unsaved
    uiCanExit(transitions) {
        let toState = transitions.to().name;
        let toParams = transitions.params();
        let currentStep = $("#uploadReqWizard").wizard('selectedItem');
        if (this._hasStepDataChanged(currentStep.step) && !this.isUiCanExit && this.isTransitionAbortRequired && toState !== "login") {
            transitions.abort();
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    if (result) {
                        if (this.isRecalcucateScoreNoClicked) {
                            this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', () => { });
                        }
                        this.isTransitionAbortRequired = false;
                        this.resetStepData(currentStep.step);
                        // Handling data change when clicked on Switch company 
                        if (this.$rootScope.switchClicked) {
                            this.$rootScope.switchClicked = false;
                            // this.companyService.showAllCompanies();
                            this.uibModalService.showAllCompanies();
                        }
                        else {
                            this.$state.go(toState, toParams, { reload: true });
                        }
                    }
                    else {
                        if (this.$rootScope.switchClicked) {
                            this.$rootScope.switchClicked = false;
                        }
                    }
                }
            });
        }
        else {
            // If clicked on switch company without changing data
            if (this.$rootScope.switchClicked && !this._hasStepDataChanged(currentStep.step)) {
                transitions.abort();
                this.$timeout(() => {
                    // this.companyService.showAllCompanies();
                    this.uibModalService.showAllCompanies();
                }, 150);
                this.$rootScope.switchClicked = false;
            }
        }
    }
    _handleBrowserEvents() {
        //Handle Browser back/forward change
        let unbindLocationChangeEvent = this.$scope.$on('$locationChangeStart', (event, toState, toParams, fromState, fromParams) => {
            this.isLocationChange = this.isLocationChangeInitial;
            this.isLocationChangeInitial = true;
        });
    }
    receiveFormalizedComment(event) {
        this.job.requisitionNote = event;
    }
    onVoiceTranscript(transcript) {
        if (this.job.requisitionNote) {
            this.job.requisitionNote += ' ' + transcript;
        }
        else {
            this.job.requisitionNote = transcript;
        }
    }
    setFormalizeActivityPayload() {
        if (this.editModeFlag) {
            this.formalizeActivityPayload = {
                candidate: null,
                requisition: new FormalizeRequisition(this.job.id, this.job.requisitionNumber, this.job.title),
                jobMatch: null,
                company: new FormalizeCompany(this.job.company.id, this.job.company.name, this.job.clientorbu.id, this.job.clientorbu.name)
            };
        }
    }
}
UploadReqPageController.$inject = ['$rootScope', '$scope', '$state', '$transitions', '$uibModal', '$sce', '$timeout', 'requisitionService', 'candidateService', 'resumeService',
    'jobService', 'assessmentService', 'planService', 'companyService', 'alertsAndNotificationsService', 'MESSAGECONSTANTS', 'uibModalService', 'utilityService', 'userService', 'manageSkillsService', 'stateManagementStorageService'];
// import * as TEMPLATE from './upload-req-page.html';
import * as TEMPLATE from 'raw-loader!./upload-req-page.html';
export const UploadReqPageComponent = {
    selector: 'uploadReqPage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/uploadreq/upload-req-page.html',
        controller: UploadReqPageController
    }
};
//# sourceMappingURL=upload-req-page.component.js.map